const allStandardLegalTrainers = [
  {
    id: "me4-76",
    name: "AZ's Tranquility",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Switch your Active Pokémon with 1 of your Benched Pokémon. If you moved a Pokémon ex to your Bench in this way, heal 80 damage from that Pokémon.",
    ],
    number: "76",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-76/small",
      large: "https://images.scrydex.com/pokemon/me4-76/large",
    },
    altArts: [
      {
        id: "me4-76",
        number: "76",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-76/small",
          large: "https://images.scrydex.com/pokemon/me4-76/large",
        },
        flavorText: "",
      },
      {
        id: "me4-106",
        number: "106",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-106/small",
          large: "https://images.scrydex.com/pokemon/me4-106/large",
        },
        flavorText: "",
      },
      {
        id: "me4-120",
        number: "120",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-120/small",
          large: "https://images.scrydex.com/pokemon/me4-120/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-54",
    name: "Academy at Night",
    supertype: "Trainer",
    subtypes: ["Stadium"],
    rules: [
      "Once during each player's turn, that player may put a card from their hand on top of their deck.",
      "You may play only 1 Stadium card during your turn. Put it next to the Active Spot, and discard it if another Stadium comes into play. A Stadium with the same name can't be played.",
    ],
    number: "54",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/54.png",
      large: "https://images.pokemontcg.io/sv6pt5/54_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-54",
        number: "54",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/54.png",
          large: "https://images.pokemontcg.io/sv6pt5/54_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-142",
    name: "Accompanying Flute",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Reveal the top 5 cards of your opponent's deck. You may choose any number of Basic Pokémon you find there and put those Pokémon onto their Bench. Your opponent shuffles the other cards back into their deck.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "142",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/142.png",
      large: "https://images.pokemontcg.io/sv6/142_hires.png",
    },
    altArts: [
      {
        id: "sv6-142",
        number: "142",
        images: {
          small: "https://images.pokemontcg.io/sv6/142.png",
          large: "https://images.pokemontcg.io/sv6/142_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-113",
    name: "Acerola's Mischief",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "You can use this card only if your opponent has 2 or fewer Prize cards remaining.  Choose 1 of your Pokémon in play. During your opponent's next turn, prevent all damage from and effects of attacks done to that Pokémon by your opponent's Pokémon ex.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "113",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/113.png",
      large: "https://images.pokemontcg.io/me1/113_hires.png",
    },
    altArts: [
      {
        id: "me1-113",
        number: "113",
        images: {
          small: "https://images.pokemontcg.io/me1/113.png",
          large: "https://images.pokemontcg.io/me1/113_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-165",
        number: "165",
        images: {
          small: "https://images.pokemontcg.io/me1/165.png",
          large: "https://images.pokemontcg.io/me1/165_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-183",
        number: "183",
        images: {
          small: "https://images.pokemontcg.io/me1/183.png",
          large: "https://images.pokemontcg.io/me1/183_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-180",
        number: "180",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-180/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-180/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-74",
    name: "Adversity Policy",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool"],
    rules: [
      "If the Pokémon this card is attached to has Weakness to your opponent's Active Pokémon's type, is in the Active Spot, and is damaged by an attack from your opponent's Pokémon (even if this Pokémon is Knocked Out), draw 3 cards.",
    ],
    number: "74",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-74/small",
      large: "https://images.scrydex.com/pokemon/me4-74/large",
    },
    altArts: [
      {
        id: "me4-74",
        number: "74",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-74/small",
          large: "https://images.scrydex.com/pokemon/me4-74/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-79",
    name: "Air Balloon",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool"],
    rules: [
      "The Retreat Cost of the Pokémon this card is attached to is ColorlessColorless less.",
      "You may attach any number of Pokémon Tools to your Pokémon during your turn. You may attach only 1 Pokémon Tool to each Pokémon, and it stays attached.",
      "Attach a Pokémon Tool to 1 of your Pokémon that doesn't already have a Pokémon Tool attached.",
    ],
    number: "79",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/79.png",
      large: "https://images.pokemontcg.io/zsv10pt5/79_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-79",
        number: "79",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/79.png",
          large: "https://images.pokemontcg.io/zsv10pt5/79_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-166",
        number: "166",
        images: {
          small: "https://images.pokemontcg.io/me1/166.png",
          large: "https://images.pokemontcg.io/me1/166_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-181",
        number: "181",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-181/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-181/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-93",
    name: "Amarys",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Draw 4 cards. At the end of this turn, if you have 5 or more cards in your hand, discard your hand.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "93",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/93.png",
      large: "https://images.pokemontcg.io/sv8pt5/93_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-93",
        number: "93",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/93.png",
          large: "https://images.pokemontcg.io/sv8pt5/93_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-132",
        number: "132",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/132.png",
          large: "https://images.pokemontcg.io/sv8pt5/132_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-170",
        number: "170",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/170.png",
          large: "https://images.pokemontcg.io/sv8pt5/170_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-162",
    name: "Amulet of Hope",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool", "ACE SPEC"],
    rules: [
      "If the Pokémon this card is attached to is Knocked Out by damage from an attack from your opponent's Pokémon, search your deck for up to 3 cards and put them into your hand. Then, shuffle your deck.",
      "You may attach any number of Pokémon Tools to your Pokémon during your turn. You may attach only 1 Pokémon Tool to each Pokémon, and it stays attached.",
      "Attach a Pokémon Tool to 1 of your Pokémon that doesn't already have a Pokémon Tool attached.",
      "ACE SPEC: You can't have more than 1 ACE SPEC card in your deck.",
    ],
    number: "162",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/162.png",
      large: "https://images.pokemontcg.io/sv8/162_hires.png",
    },
    altArts: [
      {
        id: "sv8-162",
        number: "162",
        images: {
          small: "https://images.pokemontcg.io/sv8/162.png",
          large: "https://images.pokemontcg.io/sv8/162_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-140",
    name: "Ancient Booster Energy Capsule",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool", "Ancient"],
    rules: [
      "The Ancient Pokémon this card is attached to gets +60 HP, recovers from all Special Conditions, and can't be affected by any Special Conditions.",
      "You may attach any number of Pokémon Tools to your Pokémon during your turn. You may attach only 1 Pokémon Tool to each Pokémon, and it stays attached.",
    ],
    number: "140",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/140.png",
      large: "https://images.pokemontcg.io/sv5/140_hires.png",
    },
    altArts: [
      {
        id: "sv5-140",
        number: "140",
        images: {
          small: "https://images.pokemontcg.io/sv5/140.png",
          large: "https://images.pokemontcg.io/sv5/140_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-75",
    name: "Ange Floette",
    supertype: "Trainer",
    subtypes: ["Stadium"],
    rules: [
      "You can put this card into play only if you discard a Prism Tower in play, and you can put this card into play during the same turn you play Prism Tower.\nEach Mega Floette ex in play (both yours and your opponent's) gets +150 HP.",
    ],
    number: "75",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-75/small",
      large: "https://images.scrydex.com/pokemon/me4-75/large",
    },
    altArts: [
      {
        id: "me4-75",
        number: "75",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-75/small",
          large: "https://images.scrydex.com/pokemon/me4-75/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-182",
    name: "Anthea & Concordia",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "You can use this card only if you have N's Darmanitan, N's Zoroark ex, N's Vanilluxe, N's Klinklang, N's Reshiram, and N's Zekrom in play.  During this turn, if your opponent's Active Pokémon is Knocked Out by damage from an attack used by your N's Pokémon, take 3 more Prize cards.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "182",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-182/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-182/large",
    },
    altArts: [
      {
        id: "me2pt5-182",
        number: "182",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-182/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-182/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-254",
        number: "254",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-254/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-254/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-72",
    name: "Antique Armor Fossil",
    supertype: "Trainer",
    subtypes: ["Item"],
    hp: "60",
    rules: [
      "Play this card as if it were a 60-HP Basic Colorless Pokémon. This card can't be affected by any Special Conditions and can't retreat.\n \nAt any time during your turn, you may discard this card from play.",
    ],
    abilities: [
      {
        name: "Protective Armor",
        text: "As long as this Pokémon is in the Active Spot, all of your Pokémon take 10 less damage from attacks from your opponent's Pokémon (after applying Weakness and Resistance).",
        type: "Ability",
      },
    ],
    number: "72",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-72/small",
      large: "https://images.scrydex.com/pokemon/me5-72/large",
    },
    altArts: [
      {
        id: "me5-72",
        number: "72",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-72/small",
          large: "https://images.scrydex.com/pokemon/me5-72/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-80",
    name: "Antique Cover Fossil",
    supertype: "Trainer",
    subtypes: ["Item"],
    hp: "60",
    rules: [
      "Play this card as if it were a 60-HP Basic Colorless Pokémon. This card can't be affected by any Special Conditions and can't retreat.  At any time during your turn, you may discard this card from play.",
      "You may play any number of Item cards during your turn.",
    ],
    abilities: [
      {
        name: "Protective Cover",
        text: "Prevent all effects of attacks used by your opponent's Pokémon done to this Pokémon. (Damage is not an effect.)",
        type: "Ability",
      },
    ],
    number: "60",
    flavorText:
      "They fly around at high speed, striking with their pointed spears. Even when in trouble, they face opponents bravely.",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/80.png",
      large: "https://images.pokemontcg.io/zsv10pt5/80_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-80",
        number: "60",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/80.png",
          large: "https://images.pokemontcg.io/zsv10pt5/80_hires.png",
        },
        flavorText:
          "They fly around at high speed, striking with their pointed spears. Even when in trouble, they face opponents bravely.",
      },
      {
        id: "sv7-129",
        number: "129",
        images: {
          small: "https://images.pokemontcg.io/sv7/129.png",
          large: "https://images.pokemontcg.io/sv7/129_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-68",
    name: "Antique Jaw Fossil",
    supertype: "Trainer",
    subtypes: ["Item"],
    hp: "60",
    rules: [
      "Play this card as if it were a 60-HP Basic Colorless Pokémon. This card can't be affected by any Special Conditions and can't retreat.  At any time during your turn, you may discard this card from play.",
      "You may play any number of Item cards during your turn.",
    ],
    abilities: [
      {
        name: "Intimidating Jaw",
        text: "As long as this Pokémon is in the Active Spot, attacks used by your opponent's Active Pokémon do 30 less damage (before applying Weakness and Resistance).",
        type: "Ability",
      },
    ],
    number: "68",
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-68/small",
      large: "https://images.scrydex.com/pokemon/me3-68/large",
    },
    altArts: [
      {
        id: "me3-68",
        number: "68",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-68/small",
          large: "https://images.scrydex.com/pokemon/me3-68/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-79",
    name: "Antique Plume Fossil",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Play this card as if it were a 60-HP Basic Colorless Pokémon. This card can't be affected by any Special Conditions and can't retreat.  At any time during your turn, you may discard this card from play.",
      "You may play any number of Item cards during your turn.",
    ],
    abilities: [
      {
        name: "Plume Protection",
        text: "As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks from your opponent's Pokémon.",
        type: "Ability",
      },
    ],
    number: "79",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/79.png",
      large: "https://images.pokemontcg.io/rsv10pt5/79_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-79",
        number: "79",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/79.png",
          large: "https://images.pokemontcg.io/rsv10pt5/79_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-130",
    name: "Antique Root Fossil",
    supertype: "Trainer",
    subtypes: ["Item"],
    hp: "60",
    rules: [
      "Play this card as if it were a 60-HP Basic Colorless Pokémon. This card can't be affected by any Special Conditions and can't retreat.  At any time during your turn, you may discard this card from play.",
      "You may play any number of Item cards during your turn.",
    ],
    abilities: [
      {
        name: "Primal Root",
        text: "As long as this Pokémon is in the Active Spot, attacks used by your opponent's Basic Pokémon cost Colorless more.",
        type: "Ability",
      },
    ],
    number: "130",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/130.png",
      large: "https://images.pokemontcg.io/sv7/130_hires.png",
    },
    altArts: [
      {
        id: "sv7-130",
        number: "130",
        images: {
          small: "https://images.pokemontcg.io/sv7/130.png",
          large: "https://images.pokemontcg.io/sv7/130_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-69",
    name: "Antique Sail Fossil",
    supertype: "Trainer",
    subtypes: ["Item"],
    hp: "60",
    rules: [
      "Play this card as if it were a 60-HP Basic Colorless Pokémon. This card can't be affected by any Special Conditions and can't retreat.  At any time during your turn, you may discard this card from play.",
      "You may play any number of Item cards during your turn.",
    ],
    abilities: [
      {
        name: "Protective Sail",
        text: "Whenever your opponent plays a Supporter card from their hand, prevent all effects of that card done to this Pokémon.",
        type: "Ability",
      },
    ],
    number: "69",
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-69/small",
      large: "https://images.scrydex.com/pokemon/me3-69/large",
    },
    altArts: [
      {
        id: "me3-69",
        number: "69",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-69/small",
          large: "https://images.scrydex.com/pokemon/me3-69/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-73",
    name: "Antique Skull Fossil",
    supertype: "Trainer",
    subtypes: ["Item"],
    hp: "60",
    rules: [
      "Play this card as if it were a 60-HP Basic Colorless Pokémon. This card can't be affected by any Special Conditions and can't retreat.\n \nAt any time during your turn, you may discard this card from play.",
    ],
    abilities: [
      {
        name: "Spiny Skull",
        text: "If this Pokémon is in the Active Spot and is damaged by an attack from your opponent's Pokémon (even if this Pokémon is Knocked Out), place 3 damage counters on the Attacking Pokémon.",
        type: "Ability",
      },
    ],
    number: "73",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-73/small",
      large: "https://images.scrydex.com/pokemon/me5-73/large",
    },
    altArts: [
      {
        id: "me5-73",
        number: "73",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-73/small",
          large: "https://images.scrydex.com/pokemon/me5-73/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-131",
    name: "Area Zero Underdepths",
    supertype: "Trainer",
    subtypes: ["Stadium"],
    rules: [
      "Each player who has any Tera Pokémon in play can have up to 8 Pokémon on their Bench.    If a player no longer has any Tera Pokémon in play, that player discards Pokémon from their Bench until they have 5. When this card leaves play, both players discard Pokémon from their Bench until they have 5, and the player who played this card discards first.",
      "You may play only 1 Stadium card during your turn. Put it next to the Active Spot, and discard it if another Stadium comes into play. A Stadium with the same name can't be played.",
    ],
    number: "131",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/131.png",
      large: "https://images.pokemontcg.io/sv7/131_hires.png",
    },
    altArts: [
      {
        id: "sv7-131",
        number: "131",
        images: {
          small: "https://images.pokemontcg.io/sv7/131.png",
          large: "https://images.pokemontcg.io/sv7/131_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv7-174",
        number: "174",
        images: {
          small: "https://images.pokemontcg.io/sv7/174.png",
          large: "https://images.pokemontcg.io/sv7/174_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-94",
        number: "94",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/94.png",
          large: "https://images.pokemontcg.io/sv8pt5/94_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-161",
    name: "Arven's Sandwich",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Heal 30 damage from your Active Pokémon. If that Pokémon is an Arven's Pokémon, heal 100 damage from it instead.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "161",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/161.png",
      large: "https://images.pokemontcg.io/sv10/161_hires.png",
    },
    altArts: [
      {
        id: "sv10-161",
        number: "161",
        images: {
          small: "https://images.pokemontcg.io/sv10/161.png",
          large: "https://images.pokemontcg.io/sv10/161_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-141",
    name: "Awakening Drum",
    supertype: "Trainer",
    subtypes: ["Item", "Ancient", "ACE SPEC"],
    rules: [
      "Draw a card for each of your Ancient Pokémon in play.",
      "You may play any number of Item cards during your turn.",
      "ACE SPEC: You can't have more than 1 ACE SPEC card in your deck.",
    ],
    number: "141",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/141.png",
      large: "https://images.pokemontcg.io/sv5/141_hires.png",
    },
    altArts: [
      {
        id: "sv5-141",
        number: "141",
        images: {
          small: "https://images.pokemontcg.io/sv5/141.png",
          large: "https://images.pokemontcg.io/sv5/141_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-163",
    name: "Babiri Berry",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool"],
    rules: [
      "If the Pokémon this card is attached to is damaged by an attack from your opponent's Metal Pokémon, it takes 60 less damage (after applying Weakness and Resistance), and discard this card.",
      "You may attach any number of Pokémon Tools to your Pokémon during your turn. You may attach only 1 Pokémon Tool to each Pokémon, and it stays attached.",
      "Attach a Pokémon Tool to 1 of your Pokémon that doesn't already have a Pokémon Tool attached.",
    ],
    number: "163",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/163.png",
      large: "https://images.pokemontcg.io/sv8/163_hires.png",
    },
    altArts: [
      {
        id: "sv8-163",
        number: "163",
        images: {
          small: "https://images.pokemontcg.io/sv8/163.png",
          large: "https://images.pokemontcg.io/sv8/163_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-74",
    name: "Backtrack Badge",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool"],
    rules: [
      "Once during your turn, after you flip any coins for an attack of the Colorless Pokémon this card is attached to, you may ignore all results of those coin flips and begin flipping those coins again.",
    ],
    number: "74",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-74/small",
      large: "https://images.scrydex.com/pokemon/me5-74/large",
    },
    altArts: [
      {
        id: "me5-74",
        number: "74",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-74/small",
          large: "https://images.scrydex.com/pokemon/me5-74/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-85",
    name: "Battle Cage",
    supertype: "Trainer",
    subtypes: ["Stadium"],
    rules: [
      "Prevent all damage counters from being placed on Benched Pokémon (both yours and your opponent's) by effects of attacks and Abilities from the opponent's Pokémon. (Damage from attacks is still taken.)",
      "You may play only 1 Stadium card during your turn. Put it next to the Active Spot, and discard it if another Stadium comes into play. A Stadium with the same name can't be played.",
    ],
    number: "85",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/85.png",
      large: "https://images.pokemontcg.io/me2/85_hires.png",
    },
    altArts: [
      {
        id: "me2-85",
        number: "85",
        images: {
          small: "https://images.pokemontcg.io/me2/85.png",
          large: "https://images.pokemontcg.io/me2/85_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2-116",
        number: "116",
        images: {
          small: "https://images.pokemontcg.io/me2/116.png",
          large: "https://images.pokemontcg.io/me2/116_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-142",
    name: "Bianca's Devotion",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Heal all damage from 1 of your Pokémon that has 30 HP or less remaining.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "142",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/142.png",
      large: "https://images.pokemontcg.io/sv5/142_hires.png",
    },
    altArts: [
      {
        id: "sv5-142",
        number: "142",
        images: {
          small: "https://images.pokemontcg.io/sv5/142.png",
          large: "https://images.pokemontcg.io/sv5/142_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv5-197",
        number: "197",
        images: {
          small: "https://images.pokemontcg.io/sv5/197.png",
          large: "https://images.pokemontcg.io/sv5/197_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv5-209",
        number: "209",
        images: {
          small: "https://images.pokemontcg.io/sv5/209.png",
          large: "https://images.pokemontcg.io/sv5/209_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-142",
    name: "Billy & O'Nare",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Draw 2 cards. Then, if you have 10 or more cards in your hand, draw 2 more cards.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "142",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/142.png",
      large: "https://images.pokemontcg.io/sv9/142_hires.png",
    },
    altArts: [
      {
        id: "sv9-142",
        number: "142",
        images: {
          small: "https://images.pokemontcg.io/sv9/142.png",
          large: "https://images.pokemontcg.io/sv9/142_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-55",
    name: "Binding Mochi",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool"],
    rules: [
      "Attacks used by the Poisoned Pokémon this card is attached to do 40 more damage to your opponent's Active Pokémon (before applying Weakness and Resistance).",
      "You may attach any number of Pokémon Tools to your Pokémon during your turn. You may attach only 1 Pokémon Tool to each Pokémon, and it stays attached.",
    ],
    number: "55",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/55.png",
      large: "https://images.pokemontcg.io/sv6pt5/55_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-55",
        number: "55",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/55.png",
          large: "https://images.pokemontcg.io/sv6pt5/55_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-95",
        number: "95",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/95.png",
          large: "https://images.pokemontcg.io/sv8pt5/95_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-255",
    name: "Black Belt's Training",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "During this turn, attacks used by your Pokémon do 40 more damage to your opponent's Active Pokémon ex (before applying Weakness and Resistance).",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "255",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-255/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-255/large",
    },
    altArts: [
      {
        id: "me2pt5-255",
        number: "255",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-255/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-255/large",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-96",
        number: "96",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/96.png",
          large: "https://images.pokemontcg.io/sv8pt5/96_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-97",
        number: "97",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/97.png",
          large: "https://images.pokemontcg.io/sv8pt5/97_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-98",
        number: "98",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/98.png",
          large: "https://images.pokemontcg.io/sv8pt5/98_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-99",
        number: "99",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/99.png",
          large: "https://images.pokemontcg.io/sv8pt5/99_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-143",
        number: "143",
        images: {
          small: "https://images.pokemontcg.io/sv9/143.png",
          large: "https://images.pokemontcg.io/sv9/143_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-144",
        number: "144",
        images: {
          small: "https://images.pokemontcg.io/sv9/144.png",
          large: "https://images.pokemontcg.io/sv9/144_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-145",
        number: "145",
        images: {
          small: "https://images.pokemontcg.io/sv9/145.png",
          large: "https://images.pokemontcg.io/sv9/145_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-86",
    name: "Blowtorch",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "You can use this card only if you discard a Basic Fire Energy card from your hand.  Discard a Pokémon Tool or Special Energy card from 1 of your opponent's Pokémon, or discard a Stadium in play.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "86",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/86.png",
      large: "https://images.pokemontcg.io/me2/86_hires.png",
    },
    altArts: [
      {
        id: "me2-86",
        number: "86",
        images: {
          small: "https://images.pokemontcg.io/me2/86.png",
          large: "https://images.pokemontcg.io/me2/86_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2-117",
        number: "117",
        images: {
          small: "https://images.pokemontcg.io/me2/117.png",
          large: "https://images.pokemontcg.io/me2/117_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-114",
    name: "Boss's Orders",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Switch in 1 of your opponent's Benched Pokémon to the Active Spot.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "114",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/114.png",
      large: "https://images.pokemontcg.io/me1/114_hires.png",
    },
    altArts: [
      {
        id: "me1-114",
        number: "114",
        images: {
          small: "https://images.pokemontcg.io/me1/114.png",
          large: "https://images.pokemontcg.io/me1/114_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-183",
        number: "183",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-183/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-183/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-256",
        number: "256",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-256/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-256/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-143",
    name: "Boxed Order",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Search your deck for up to 2 Item cards, reveal them, and put them into your hand. Then, shuffle your deck. Your turn ends.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "143",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/143.png",
      large: "https://images.pokemontcg.io/sv5/143_hires.png",
    },
    altArts: [
      {
        id: "sv5-143",
        number: "143",
        images: {
          small: "https://images.pokemontcg.io/sv5/143.png",
          large: "https://images.pokemontcg.io/sv5/143_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-80",
    name: "Brave Bangle",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool"],
    rules: [
      "If the Pokémon this card is attached to doesn't have a Rule Box, the attacks it uses do 30 more damage to your opponent's Active Pokémon ex (before applying Weakness and Resistance). (Pokémon ex, Pokémon V, etc. have Rule Boxes.)",
      "You may attach any number of Pokémon Tools to your Pokémon during your turn. You may attach only 1 Pokémon Tool to each Pokémon, and it stays attached.",
      "Attach a Pokémon Tool to 1 of your Pokémon that doesn't already have a Pokémon Tool attached.",
    ],
    number: "80",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/80.png",
      large: "https://images.pokemontcg.io/rsv10pt5/80_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-80",
        number: "80",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/80.png",
          large: "https://images.pokemontcg.io/rsv10pt5/80_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me5-104",
        number: "104",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-104/small",
          large: "https://images.scrydex.com/pokemon/me5-104/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-132",
    name: "Briar",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "You can use this card only if your opponent has exactly 2 Prize cards remaining.    During this turn, if your opponent's Active Pokémon is Knocked Out by damage from an attack used by your Tera Pokémon, take 1 more Prize card.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "132",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/132.png",
      large: "https://images.pokemontcg.io/sv7/132_hires.png",
    },
    altArts: [
      {
        id: "sv7-132",
        number: "132",
        images: {
          small: "https://images.pokemontcg.io/sv7/132.png",
          large: "https://images.pokemontcg.io/sv7/132_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv7-163",
        number: "163",
        images: {
          small: "https://images.pokemontcg.io/sv7/163.png",
          large: "https://images.pokemontcg.io/sv7/163_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv7-171",
        number: "171",
        images: {
          small: "https://images.pokemontcg.io/sv7/171.png",
          large: "https://images.pokemontcg.io/sv7/171_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-100",
        number: "100",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/100.png",
          large: "https://images.pokemontcg.io/sv8pt5/100_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-164",
    name: "Brilliant Blender",
    supertype: "Trainer",
    subtypes: ["Item", "ACE SPEC"],
    rules: [
      "Search your deck for up to 5 cards and discard them. Then, shuffle your deck.",
      "You may play any number of Item cards during your turn.",
      "ACE SPEC: You can't have more than 1 ACE SPEC card in your deck.",
    ],
    number: "164",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/164.png",
      large: "https://images.pokemontcg.io/sv8/164_hires.png",
    },
    altArts: [
      {
        id: "sv8-164",
        number: "164",
        images: {
          small: "https://images.pokemontcg.io/sv8/164.png",
          large: "https://images.pokemontcg.io/sv8/164_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-146",
    name: "Brock's Scouting",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Search your deck for up to 2 Basic Pokémon or 1 Evolution Pokémon, reveal them, and put them into your hand. Then, shuffle your deck.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "146",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/146.png",
      large: "https://images.pokemontcg.io/sv9/146_hires.png",
    },
    altArts: [
      {
        id: "sv9-146",
        number: "146",
        images: {
          small: "https://images.pokemontcg.io/sv9/146.png",
          large: "https://images.pokemontcg.io/sv9/146_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-179",
        number: "179",
        images: {
          small: "https://images.pokemontcg.io/sv9/179.png",
          large: "https://images.pokemontcg.io/sv9/179_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-167",
    name: "Buddy-Buddy Poffin",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Search your deck for up to 2 Basic Pokémon with 70 HP or less and put them onto your Bench. Then, shuffle your deck.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "167",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/me1/167.png",
      large: "https://images.pokemontcg.io/me1/167_hires.png",
    },
    altArts: [
      {
        id: "me1-167",
        number: "167",
        images: {
          small: "https://images.pokemontcg.io/me1/167.png",
          large: "https://images.pokemontcg.io/me1/167_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-184",
        number: "184",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-184/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-184/large",
        },
        flavorText: "",
      },
      {
        id: "sv5-144",
        number: "144",
        images: {
          small: "https://images.pokemontcg.io/sv5/144.png",
          large: "https://images.pokemontcg.io/sv5/144_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-223",
        number: "223",
        images: {
          small: "https://images.pokemontcg.io/sv6/223.png",
          large: "https://images.pokemontcg.io/sv6/223_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-101",
        number: "101",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/101.png",
          large: "https://images.pokemontcg.io/sv8pt5/101_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-143",
    name: "Bug Catching Set",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Look at the top 7 cards of your deck. You may reveal up to 2 in any combination of Grass Pokémon and Basic Grass Energy cards you find there and put them into your hand. Shuffle the other cards back into your deck.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "143",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/143.png",
      large: "https://images.pokemontcg.io/sv6/143_hires.png",
    },
    altArts: [
      {
        id: "sv6-143",
        number: "143",
        images: {
          small: "https://images.pokemontcg.io/sv6/143.png",
          large: "https://images.pokemontcg.io/sv6/143_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-102",
        number: "102",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/102.png",
          large: "https://images.pokemontcg.io/sv8pt5/102_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-165",
    name: "Call Bell",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "You can use this card only if you go second, and only during your first turn.  Search your deck for a Supporter card, reveal it, and put it into your hand. Then, shuffle your deck.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "165",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/165.png",
      large: "https://images.pokemontcg.io/sv8/165_hires.png",
    },
    altArts: [
      {
        id: "sv8-165",
        number: "165",
        images: {
          small: "https://images.pokemontcg.io/sv8/165.png",
          large: "https://images.pokemontcg.io/sv8/165_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-185",
    name: "Canari",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "You can use this card only if you discard another card from your hand.  Search your deck for up to 4 Lightning Pokémon, reveal them, and put them into your hand. Then, shuffle your deck.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "185",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-185/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-185/large",
    },
    altArts: [
      {
        id: "me2pt5-185",
        number: "185",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-185/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-185/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-257",
        number: "257",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-257/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-257/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-291",
        number: "291",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-291/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-291/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-144",
    name: "Caretaker",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Draw 2 cards. If you drew any cards in this way and if Community Center is in play, shuffle this Caretaker into your deck instead of discarding it.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "144",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/144.png",
      large: "https://images.pokemontcg.io/sv6/144_hires.png",
    },
    altArts: [
      {
        id: "sv6-144",
        number: "144",
        images: {
          small: "https://images.pokemontcg.io/sv6/144.png",
          large: "https://images.pokemontcg.io/sv6/144_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-203",
        number: "203",
        images: {
          small: "https://images.pokemontcg.io/sv6/203.png",
          large: "https://images.pokemontcg.io/sv6/203_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-145",
    name: "Carmine",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "If you go first, you may use this card during your first turn.    Discard your hand and draw 5 cards.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "145",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/145.png",
      large: "https://images.pokemontcg.io/sv6/145_hires.png",
    },
    altArts: [
      {
        id: "sv6-145",
        number: "145",
        images: {
          small: "https://images.pokemontcg.io/sv6/145.png",
          large: "https://images.pokemontcg.io/sv6/145_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-204",
        number: "204",
        images: {
          small: "https://images.pokemontcg.io/sv6/204.png",
          large: "https://images.pokemontcg.io/sv6/204_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-217",
        number: "217",
        images: {
          small: "https://images.pokemontcg.io/sv6/217.png",
          large: "https://images.pokemontcg.io/sv6/217_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-103",
        number: "103",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/103.png",
          large: "https://images.pokemontcg.io/sv8pt5/103_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-56",
    name: "Cassiopeia",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "You can use this card only when it is the last card in your hand.  Search your deck for up to 2 cards and put them into your hand. Then, shuffle your deck.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "56",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/56.png",
      large: "https://images.pokemontcg.io/sv6pt5/56_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-56",
        number: "56",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/56.png",
          large: "https://images.pokemontcg.io/sv6pt5/56_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6pt5-86",
        number: "86",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/86.png",
          large: "https://images.pokemontcg.io/sv6pt5/86_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6pt5-94",
        number: "94",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/94.png",
          large: "https://images.pokemontcg.io/sv6pt5/94_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-81",
    name: "Cheren",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Draw 3 cards.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "81",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/81.png",
      large: "https://images.pokemontcg.io/rsv10pt5/81_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-81",
        number: "81",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/81.png",
          large: "https://images.pokemontcg.io/rsv10pt5/81_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-258",
        number: "258",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-258/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-258/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-166",
    name: "Chill Teaser Toy",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "You can use this card only if you go second, and only during your first turn.  Put an Energy attached to 1 of your opponent's Pokémon into their hand.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "166",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/166.png",
      large: "https://images.pokemontcg.io/sv8/166_hires.png",
    },
    altArts: [
      {
        id: "sv8-166",
        number: "166",
        images: {
          small: "https://images.pokemontcg.io/sv8/166.png",
          large: "https://images.pokemontcg.io/sv8/166_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-145",
    name: "Ciphermaniac's Codebreaking",
    supertype: "Trainer",
    subtypes: ["Supporter", "Future"],
    rules: [
      "Search your deck for 2 cards, shuffle your deck, then put those cards on top of it in any order.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "145",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/145.png",
      large: "https://images.pokemontcg.io/sv5/145_hires.png",
    },
    altArts: [
      {
        id: "sv5-145",
        number: "145",
        images: {
          small: "https://images.pokemontcg.io/sv5/145.png",
          large: "https://images.pokemontcg.io/sv5/145_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv5-198",
        number: "198",
        images: {
          small: "https://images.pokemontcg.io/sv5/198.png",
          large: "https://images.pokemontcg.io/sv5/198_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-104",
        number: "104",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/104.png",
          large: "https://images.pokemontcg.io/sv8pt5/104_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-167",
    name: "Clemont's Quick Wit",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Heal 60 damage from each of your Lightning Pokémon.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "167",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/167.png",
      large: "https://images.pokemontcg.io/sv8/167_hires.png",
    },
    altArts: [
      {
        id: "sv8-167",
        number: "167",
        images: {
          small: "https://images.pokemontcg.io/sv8/167.png",
          large: "https://images.pokemontcg.io/sv8/167_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-229",
        number: "229",
        images: {
          small: "https://images.pokemontcg.io/sv8/229.png",
          large: "https://images.pokemontcg.io/sv8/229_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-243",
        number: "243",
        images: {
          small: "https://images.pokemontcg.io/sv8/243.png",
          large: "https://images.pokemontcg.io/sv8/243_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-168",
    name: "Colbur Berry",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool"],
    rules: [
      "If the Pokémon this card is attached to is damaged by an attack from your opponent's Darkness Pokémon, it takes 60 less damage (after applying Weakness and Resistance), and discard this card.",
      "You may attach any number of Pokémon Tools to your Pokémon during your turn. You may attach only 1 Pokémon Tool to each Pokémon, and it stays attached.",
      "Attach a Pokémon Tool to 1 of your Pokémon that doesn't already have a Pokémon Tool attached.",
    ],
    number: "168",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/168.png",
      large: "https://images.pokemontcg.io/sv8/168_hires.png",
    },
    altArts: [
      {
        id: "sv8-168",
        number: "168",
        images: {
          small: "https://images.pokemontcg.io/sv8/168.png",
          large: "https://images.pokemontcg.io/sv8/168_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-57",
    name: "Colress's Tenacity",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Search your deck for a Stadium card and an Energy card, reveal them, and put them into your hand. Then, shuffle your deck.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "57",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/57.png",
      large: "https://images.pokemontcg.io/sv6pt5/57_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-57",
        number: "57",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/57.png",
          large: "https://images.pokemontcg.io/sv6pt5/57_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6pt5-87",
        number: "87",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/87.png",
          large: "https://images.pokemontcg.io/sv6pt5/87_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-146",
    name: "Community Center",
    supertype: "Trainer",
    subtypes: ["Stadium"],
    rules: [
      "Once during each player's turn, if they played a Supporter card from their hand this turn, they may heal 10 damage from each of their Pokémon.",
      "You may play only 1 Stadium card during your turn. Put it next to the Active Spot, and discard it if another Stadium comes into play. A Stadium with the same name can't be played.",
      "You may play only 1 Stadium card during your turn. Put it into the Active Spot, and discard it if another Stadium comes into play. A Stadium with the same name can't be played.",
    ],
    number: "146",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/146.png",
      large: "https://images.pokemontcg.io/sv6/146_hires.png",
    },
    altArts: [
      {
        id: "sv6-146",
        number: "146",
        images: {
          small: "https://images.pokemontcg.io/sv6/146.png",
          large: "https://images.pokemontcg.io/sv6/146_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-147",
    name: "Cook",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Heal 70 damage from your Active Pokémon.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "147",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/147.png",
      large: "https://images.pokemontcg.io/sv6/147_hires.png",
    },
    altArts: [
      {
        id: "sv6-147",
        number: "147",
        images: {
          small: "https://images.pokemontcg.io/sv6/147.png",
          large: "https://images.pokemontcg.io/sv6/147_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-70",
    name: "Core Memory",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool"],
    rules: [
      "The Mega Zygarde ex this card is attached to can use the attack on this card. (You still need the necessary Energy to use this attack.)",
      "You may attach any number of Pokémon Tools to your Pokémon during your turn. You may attach only 1 Pokémon Tool to each Pokémon, and it stays attached.",
    ],
    attacks: [
      {
        name: "Geobuster",
        cost: ["Fighting", "Fighting", "Fighting", "Fighting"],
        convertedEnergyCost: 4,
        damage: "350",
        text: "Discard all Energy from this Pokémon.",
      },
    ],
    number: "70",
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-70/small",
      large: "https://images.scrydex.com/pokemon/me3-70/large",
    },
    altArts: [
      {
        id: "me3-70",
        number: "70",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-70/small",
          large: "https://images.scrydex.com/pokemon/me3-70/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-186",
    name: "Counter Gain",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool"],
    rules: [
      "If you have more Prize cards remaining than your opponent, attacks used by the Pokémon this card is attached to cost Colorless less.",
      "You may attach any number of Pokémon Tools to your Pokémon during your turn. You may attach only 1 Pokémon Tool to each Pokémon, and it stays attached.",
    ],
    number: "186",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-186/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-186/large",
    },
    altArts: [
      {
        id: "me2pt5-186",
        number: "186",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-186/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-186/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-259",
        number: "259",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-259/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-259/large",
        },
        flavorText: "",
      },
      {
        id: "sv8-169",
        number: "169",
        images: {
          small: "https://images.pokemontcg.io/sv8/169.png",
          large: "https://images.pokemontcg.io/sv8/169_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-249",
        number: "249",
        images: {
          small: "https://images.pokemontcg.io/sv8/249.png",
          large: "https://images.pokemontcg.io/sv8/249_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-133",
    name: "Crispin",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Search your deck for up to 2 Basic Energy cards of different types, reveal them, and put 1 of them into your hand. Attach the other to 1 of your Pokémon. Then, shuffle your deck.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "133",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/133.png",
      large: "https://images.pokemontcg.io/sv7/133_hires.png",
    },
    altArts: [
      {
        id: "sv7-133",
        number: "133",
        images: {
          small: "https://images.pokemontcg.io/sv7/133.png",
          large: "https://images.pokemontcg.io/sv7/133_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv7-164",
        number: "164",
        images: {
          small: "https://images.pokemontcg.io/sv7/164.png",
          large: "https://images.pokemontcg.io/sv7/164_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-105",
        number: "105",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/105.png",
          large: "https://images.pokemontcg.io/sv8pt5/105_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-171",
        number: "171",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/171.png",
          large: "https://images.pokemontcg.io/sv8pt5/171_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-71",
    name: "Crushing Hammer",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Flip a coin. If heads, discard an Energy from 1 of your opponent's Pokémon.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "71",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-71/small",
      large: "https://images.scrydex.com/pokemon/me3-71/large",
    },
    altArts: [
      {
        id: "me3-71",
        number: "71",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-71/small",
          large: "https://images.scrydex.com/pokemon/me3-71/large",
        },
        flavorText: "",
      },
      {
        id: "me5-105",
        number: "105",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-105/small",
          large: "https://images.scrydex.com/pokemon/me5-105/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-162",
    name: "Cynthia's Power Weight",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool"],
    rules: [
      "The Cynthia's Pokémon this card is attached to gets +70 HP.",
      "You may attach any number of Pokémon Tools to your Pokémon during your turn. You may attach only 1 Pokémon Tool to each Pokémon, and it stays attached.",
    ],
    number: "162",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/162.png",
      large: "https://images.pokemontcg.io/sv10/162_hires.png",
    },
    altArts: [
      {
        id: "sv10-162",
        number: "162",
        images: {
          small: "https://images.pokemontcg.io/sv10/162.png",
          large: "https://images.pokemontcg.io/sv10/162_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-170",
    name: "Cyrano",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Search your deck for up to 3 Pokémon ex, reveal them, and put them into your hand. Then, shuffle your deck.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "170",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/170.png",
      large: "https://images.pokemontcg.io/sv8/170_hires.png",
    },
    altArts: [
      {
        id: "sv8-170",
        number: "170",
        images: {
          small: "https://images.pokemontcg.io/sv8/170.png",
          large: "https://images.pokemontcg.io/sv8/170_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-230",
        number: "230",
        images: {
          small: "https://images.pokemontcg.io/sv8/230.png",
          large: "https://images.pokemontcg.io/sv8/230_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-58",
    name: "Dangerous Laser",
    supertype: "Trainer",
    subtypes: ["Item", "ACE SPEC"],
    rules: [
      "You can't have more than 1 ACE SPEC card in your deck.",
      "Your opponent's Active Pokémon is now Burned and Confused.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "58",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/58.png",
      large: "https://images.pokemontcg.io/sv6pt5/58_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-58",
        number: "58",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/58.png",
          large: "https://images.pokemontcg.io/sv6pt5/58_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-75",
    name: "Dark Bell",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: ["Both Active non-Darkness Pokémon are now Confused."],
    number: "75",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-75/small",
      large: "https://images.scrydex.com/pokemon/me5-75/large",
    },
    altArts: [
      {
        id: "me5-75",
        number: "75",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-75/small",
          large: "https://images.scrydex.com/pokemon/me5-75/large",
        },
        flavorText: "",
      },
      {
        id: "me5-106",
        number: "106",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-106/small",
          large: "https://images.scrydex.com/pokemon/me5-106/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-87",
    name: "Dawn",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Search your deck for a Basic Pokémon, a Stage 1 Pokémon, and a Stage 2 Pokémon, reveal them, and put them into your hand. Then, shuffle your deck.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "87",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/87.png",
      large: "https://images.pokemontcg.io/me2/87_hires.png",
    },
    altArts: [
      {
        id: "me2-87",
        number: "87",
        images: {
          small: "https://images.pokemontcg.io/me2/87.png",
          large: "https://images.pokemontcg.io/me2/87_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2-118",
        number: "118",
        images: {
          small: "https://images.pokemontcg.io/me2/118.png",
          large: "https://images.pokemontcg.io/me2/118_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2-129",
        number: "129",
        images: {
          small: "https://images.pokemontcg.io/me2/129.png",
          large: "https://images.pokemontcg.io/me2/129_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-171",
    name: "Deduction Kit",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Look at the top 3 cards of your deck and put them back in any order, or shuffle them and put them on the bottom of your deck.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "171",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/171.png",
      large: "https://images.pokemontcg.io/sv8/171_hires.png",
    },
    altArts: [
      {
        id: "sv8-171",
        number: "171",
        images: {
          small: "https://images.pokemontcg.io/sv8/171.png",
          large: "https://images.pokemontcg.io/sv8/171_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-134",
    name: "Deluxe Bomb",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool", "ACE SPEC"],
    rules: [
      "You can't have more than 1 ACE SPEC card in your deck.",
      "If the Pokémon this card is attached to is in the Active Spot and is damaged by an attack from your opponent's Pokémon (even if this Pokémon is Knocked Out), put 12 damage counters on the Attacking Pokémon. If you placed any damage counters in this way, discard this card.",
      "You may attach any number of Pokémon Tools to your Pokémon during your turn. You may attach only 1 Pokémon Tool to each Pokémon, and it stays attached.",
    ],
    number: "134",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/134.png",
      large: "https://images.pokemontcg.io/sv7/134_hires.png",
    },
    altArts: [
      {
        id: "sv7-134",
        number: "134",
        images: {
          small: "https://images.pokemontcg.io/sv7/134.png",
          large: "https://images.pokemontcg.io/sv7/134_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-88",
    name: "Dizzying Valley",
    supertype: "Trainer",
    subtypes: ["Stadium"],
    rules: [
      "Confused Pokémon (both yours and your opponent's) don't recover from that Special Condition when they evolve or devolve.",
      "You may play only 1 Stadium card during your turn. Put it next to the Active Spot, and discard it if another Stadium comes into play. A Stadium with the same name can't be played.",
    ],
    number: "88",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/88.png",
      large: "https://images.pokemontcg.io/me2/88_hires.png",
    },
    altArts: [
      {
        id: "me2-88",
        number: "88",
        images: {
          small: "https://images.pokemontcg.io/me2/88.png",
          large: "https://images.pokemontcg.io/me2/88_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-172",
    name: "Dragon Elixir",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Heal 60 damage from your Active Dragon Pokémon.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "172",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/172.png",
      large: "https://images.pokemontcg.io/sv8/172_hires.png",
    },
    altArts: [
      {
        id: "sv8-172",
        number: "172",
        images: {
          small: "https://images.pokemontcg.io/sv8/172.png",
          large: "https://images.pokemontcg.io/sv8/172_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-173",
    name: "Drasna",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Shuffle your hand into your deck. Then, flip a coin. If heads, draw 8 cards. If tails, draw 3 cards.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "173",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/173.png",
      large: "https://images.pokemontcg.io/sv8/173_hires.png",
    },
    altArts: [
      {
        id: "sv8-173",
        number: "173",
        images: {
          small: "https://images.pokemontcg.io/sv8/173.png",
          large: "https://images.pokemontcg.io/sv8/173_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-231",
        number: "231",
        images: {
          small: "https://images.pokemontcg.io/sv8/231.png",
          large: "https://images.pokemontcg.io/sv8/231_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-174",
    name: "Drayton",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Look at the top 7 cards of your deck. You may reveal a Pokémon and a Trainer card you find there and put them into your hand. Shuffle the other cards back into your deck.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "174",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/174.png",
      large: "https://images.pokemontcg.io/sv8/174_hires.png",
    },
    altArts: [
      {
        id: "sv8-174",
        number: "174",
        images: {
          small: "https://images.pokemontcg.io/sv8/174.png",
          large: "https://images.pokemontcg.io/sv8/174_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-232",
        number: "232",
        images: {
          small: "https://images.pokemontcg.io/sv8/232.png",
          large: "https://images.pokemontcg.io/sv8/232_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-244",
        number: "244",
        images: {
          small: "https://images.pokemontcg.io/sv8/244.png",
          large: "https://images.pokemontcg.io/sv8/244_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-172",
        number: "172",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/172.png",
          large: "https://images.pokemontcg.io/sv8pt5/172_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-175",
    name: "Dusk Ball",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Look at the bottom 7 cards of your deck. You may reveal a Pokémon you find there and put it into your hand. Shuffle the other cards back into your deck.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "175",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/175.png",
      large: "https://images.pokemontcg.io/sv8/175_hires.png",
    },
    altArts: [
      {
        id: "sv8-175",
        number: "175",
        images: {
          small: "https://images.pokemontcg.io/sv8/175.png",
          large: "https://images.pokemontcg.io/sv8/175_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-163",
    name: "Emcee's Hype",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Draw 2 cards. If your opponent has 3 or fewer Prize cards remaining, draw 2 more cards.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "163",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/163.png",
      large: "https://images.pokemontcg.io/sv10/163_hires.png",
    },
    altArts: [
      {
        id: "sv10-163",
        number: "163",
        images: {
          small: "https://images.pokemontcg.io/sv10/163.png",
          large: "https://images.pokemontcg.io/sv10/163_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-220",
        number: "220",
        images: {
          small: "https://images.pokemontcg.io/sv10/220.png",
          large: "https://images.pokemontcg.io/sv10/220_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-77",
    name: "Emma",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Your opponent reveals their hand, and you draw a card for each Pokémon you find there.",
    ],
    number: "77",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-77/small",
      large: "https://images.scrydex.com/pokemon/me4-77/large",
    },
    altArts: [
      {
        id: "me4-77",
        number: "77",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-77/small",
          large: "https://images.scrydex.com/pokemon/me4-77/large",
        },
        flavorText: "",
      },
      {
        id: "me4-107",
        number: "107",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-107/small",
          large: "https://images.scrydex.com/pokemon/me4-107/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-81",
    name: "Energy Coin",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Flip 2 coins. If both of them are heads, search your deck for a Basic Energy card and attach it to 1 of your Pokémon. Then, shuffle your deck.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "81",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/81.png",
      large: "https://images.pokemontcg.io/zsv10pt5/81_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-81",
        number: "81",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/81.png",
          large: "https://images.pokemontcg.io/zsv10pt5/81_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-108",
    name: "Energy Recycler",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Shuffle up to 5 Basic Energy cards from your discard pile into your deck.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "108",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-108/small",
      large: "https://images.scrydex.com/pokemon/me3-108/large",
    },
    altArts: [
      {
        id: "me3-108",
        number: "108",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-108/small",
          large: "https://images.scrydex.com/pokemon/me3-108/large",
        },
        flavorText: "",
      },
      {
        id: "sv10-164",
        number: "164",
        images: {
          small: "https://images.pokemontcg.io/sv10/164.png",
          large: "https://images.pokemontcg.io/sv10/164_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-82",
    name: "Energy Retrieval",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Put up to 2 Basic Energy cards from your discard pile into your hand.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "82",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/82.png",
      large: "https://images.pokemontcg.io/rsv10pt5/82_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-82",
        number: "82",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/82.png",
          large: "https://images.pokemontcg.io/rsv10pt5/82_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me4-108",
        number: "108",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-108/small",
          large: "https://images.scrydex.com/pokemon/me4-108/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-72",
    name: "Energy Search",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Search your deck for a Basic Energy card, reveal it, and put it into your hand. Then, shuffle your deck.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "72",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-72/small",
      large: "https://images.scrydex.com/pokemon/me3-72/large",
    },
    altArts: [
      {
        id: "me3-72",
        number: "72",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-72/small",
          large: "https://images.scrydex.com/pokemon/me3-72/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-176",
    name: "Energy Search Pro",
    supertype: "Trainer",
    subtypes: ["Item", "ACE SPEC"],
    rules: [
      "Search your deck for any number of Basic Energy cards of different types, reveal them, and put them into your hand. Then, shuffle your deck.",
      "You may play any number of Item cards during your turn.",
      "ACE SPEC: You can't have more than 1 ACE SPEC card in your deck.",
    ],
    number: "176",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/176.png",
      large: "https://images.pokemontcg.io/sv8/176_hires.png",
    },
    altArts: [
      {
        id: "sv8-176",
        number: "176",
        images: {
          small: "https://images.pokemontcg.io/sv8/176.png",
          large: "https://images.pokemontcg.io/sv8/176_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-73",
    name: "Energy Swatter",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Your opponent reveals their hand, and you choose an Energy card you find there and put it on the bottom of their deck.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "73",
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-73/small",
      large: "https://images.scrydex.com/pokemon/me3-73/large",
    },
    altArts: [
      {
        id: "me3-73",
        number: "73",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-73/small",
          large: "https://images.scrydex.com/pokemon/me3-73/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-115",
    name: "Energy Switch",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Move a Basic Energy from 1 of your Pokémon to another of your Pokémon.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "115",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/115.png",
      large: "https://images.pokemontcg.io/me1/115_hires.png",
    },
    altArts: [
      {
        id: "me1-115",
        number: "115",
        images: {
          small: "https://images.pokemontcg.io/me1/115.png",
          large: "https://images.pokemontcg.io/me1/115_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me5-107",
        number: "107",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-107/small",
          large: "https://images.scrydex.com/pokemon/me5-107/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-148",
    name: "Enhanced Hammer",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Discard a Special Energy from 1 of your opponent's Pokémon.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "148",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/148.png",
      large: "https://images.pokemontcg.io/sv6/148_hires.png",
    },
    altArts: [
      {
        id: "sv6-148",
        number: "148",
        images: {
          small: "https://images.pokemontcg.io/sv6/148.png",
          large: "https://images.pokemontcg.io/sv6/148_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-224",
        number: "224",
        images: {
          small: "https://images.pokemontcg.io/sv6/224.png",
          large: "https://images.pokemontcg.io/sv6/224_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-146",
    name: "Eri",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Your opponent reveals their hand, and you discard up to 2 Item cards you find there.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "146",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/146.png",
      large: "https://images.pokemontcg.io/sv5/146_hires.png",
    },
    altArts: [
      {
        id: "sv5-146",
        number: "146",
        images: {
          small: "https://images.pokemontcg.io/sv5/146.png",
          large: "https://images.pokemontcg.io/sv5/146_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv5-199",
        number: "199",
        images: {
          small: "https://images.pokemontcg.io/sv5/199.png",
          large: "https://images.pokemontcg.io/sv5/199_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv5-210",
        number: "210",
        images: {
          small: "https://images.pokemontcg.io/sv5/210.png",
          large: "https://images.pokemontcg.io/sv5/210_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-136",
        number: "136",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/136.png",
          large: "https://images.pokemontcg.io/sv8pt5/136_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55c-69",
    name: "Erika's Jigglypuff",
    supertype: "Trainer",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Colorless"],
    attacks: [
      {
        name: "Group Therapy",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        text: "You and your opponent remove 1 damage counter from each of your Pokémon with damage counters on them.",
      },
      {
        name: "Pulled Punch",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40-",
        text: "If the Defending Pokémon has no damage counters on it, this attack does 40 damage. If it has any damage counters on it, this attack does 10 damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Psychic",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "69",
    images: {
      small: "https://images.scrydex.com/pokemon/me55c-69/small",
      large: "https://images.scrydex.com/pokemon/me55c-69/large",
    },
    altArts: [
      {
        id: "me55c-69",
        number: "69",
        images: {
          small: "https://images.scrydex.com/pokemon/me55c-69/small",
          large: "https://images.scrydex.com/pokemon/me55c-69/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-165",
    name: "Ethan's Adventure",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Search your deck for up to 3 in any combination of Ethan's Pokémon and Basic Fire Energy cards, reveal them, and put them into your hand. Then, shuffle your deck.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "165",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/165.png",
      large: "https://images.pokemontcg.io/sv10/165_hires.png",
    },
    altArts: [
      {
        id: "sv10-165",
        number: "165",
        images: {
          small: "https://images.pokemontcg.io/sv10/165.png",
          large: "https://images.pokemontcg.io/sv10/165_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-221",
        number: "221",
        images: {
          small: "https://images.pokemontcg.io/sv10/221.png",
          large: "https://images.pokemontcg.io/sv10/221_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-236",
        number: "236",
        images: {
          small: "https://images.pokemontcg.io/sv10/236.png",
          large: "https://images.pokemontcg.io/sv10/236_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-147",
    name: "Explorer's Guidance",
    supertype: "Trainer",
    subtypes: ["Supporter", "Ancient"],
    rules: [
      "Look at the top 6 cards of your deck and put 2 of them into your hand. Discard the other cards.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "147",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/147.png",
      large: "https://images.pokemontcg.io/sv5/147_hires.png",
    },
    altArts: [
      {
        id: "sv5-147",
        number: "147",
        images: {
          small: "https://images.pokemontcg.io/sv5/147.png",
          large: "https://images.pokemontcg.io/sv5/147_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv5-200",
        number: "200",
        images: {
          small: "https://images.pokemontcg.io/sv5/200.png",
          large: "https://images.pokemontcg.io/sv5/200_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-107",
        number: "107",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/107.png",
          large: "https://images.pokemontcg.io/sv8pt5/107_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-82",
    name: "Fennel",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Heal 40 damage from each of your Pokémon.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "82",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/82.png",
      large: "https://images.pokemontcg.io/zsv10pt5/82_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-82",
        number: "82",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/82.png",
          large: "https://images.pokemontcg.io/zsv10pt5/82_hires.png",
        },
        flavorText: "",
      },
      {
        id: "zsv10pt5-162",
        number: "162",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/162.png",
          large: "https://images.pokemontcg.io/zsv10pt5/162_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-149",
    name: "Festival Grounds",
    supertype: "Trainer",
    subtypes: ["Stadium"],
    rules: [
      "Each Pokémon that has any Energy attached (both yours and your opponent's) recovers from all Special Conditions and can't be affected by any Special Conditions.",
      "You may play only 1 Stadium card during your turn. Put it into the Active Spot, and discard it if another Stadium comes into play. A Stadium with the same name can't be played.",
    ],
    number: "149",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/149.png",
      large: "https://images.pokemontcg.io/sv6/149_hires.png",
    },
    altArts: [
      {
        id: "sv6-149",
        number: "149",
        images: {
          small: "https://images.pokemontcg.io/sv6/149.png",
          large: "https://images.pokemontcg.io/sv6/149_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-108",
        number: "108",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/108.png",
          large: "https://images.pokemontcg.io/sv8pt5/108_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-116",
    name: "Fighting Gong",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Search your deck for a Basic Fighting Energy card or a Basic Fighting Pokémon, reveal it, and put it into your hand. Then, shuffle your deck.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "116",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/116.png",
      large: "https://images.pokemontcg.io/me1/116_hires.png",
    },
    altArts: [
      {
        id: "me1-116",
        number: "116",
        images: {
          small: "https://images.pokemontcg.io/me1/116.png",
          large: "https://images.pokemontcg.io/me1/116_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-168",
        number: "168",
        images: {
          small: "https://images.pokemontcg.io/me1/168.png",
          large: "https://images.pokemontcg.io/me1/168_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-187",
        number: "187",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-187/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-187/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-89",
    name: "Firebreather",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Search your deck for up to 7 Basic Fire Energy cards, reveal them, and put them into your hand. Then, shuffle your deck.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "89",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/89.png",
      large: "https://images.pokemontcg.io/me2/89_hires.png",
    },
    altArts: [
      {
        id: "me2-89",
        number: "89",
        images: {
          small: "https://images.pokemontcg.io/me2/89.png",
          large: "https://images.pokemontcg.io/me2/89_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2-119",
        number: "119",
        images: {
          small: "https://images.pokemontcg.io/me2/119.png",
          large: "https://images.pokemontcg.io/me2/119_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-117",
    name: "Forest of Vitality",
    supertype: "Trainer",
    subtypes: ["Stadium"],
    rules: [
      "Each player's Grass Pokémon can evolve into Grass Pokémon during the turn they play those Pokémon, except during their first turn.",
      "You may play only 1 Stadium card during your turn. Put it next to the Active Spot, and discard it if another Stadium comes into play. A Stadium with the same name can't be played.",
    ],
    number: "117",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/117.png",
      large: "https://images.pokemontcg.io/me1/117_hires.png",
    },
    altArts: [
      {
        id: "me1-117",
        number: "117",
        images: {
          small: "https://images.pokemontcg.io/me1/117.png",
          large: "https://images.pokemontcg.io/me1/117_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-188",
        number: "188",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-188/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-188/large",
        },
        flavorText: "",
      },
      {
        id: "me3-109",
        number: "109",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-109/small",
          large: "https://images.scrydex.com/pokemon/me3-109/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-76",
    name: "Fossil Quarry",
    supertype: "Trainer",
    subtypes: ["Stadium"],
    rules: [
      'Once during each player\'s turn, that player may search their deck for up to 2 Item cards that have "Antique" in their name and put them onto their Bench. Then, that player shuffles their deck.',
    ],
    number: "76",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-76/small",
      large: "https://images.scrydex.com/pokemon/me5-76/large",
    },
    altArts: [
      {
        id: "me5-76",
        number: "76",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-76/small",
          large: "https://images.scrydex.com/pokemon/me5-76/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-109",
    name: "Friends in Paldea",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Draw 3 cards.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "109",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/109.png",
      large: "https://images.pokemontcg.io/sv8pt5/109_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-109",
        number: "109",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/109.png",
          large: "https://images.pokemontcg.io/sv8pt5/109_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-137",
        number: "137",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/137.png",
          large: "https://images.pokemontcg.io/sv8pt5/137_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-148",
    name: "Full Metal Lab",
    supertype: "Trainer",
    subtypes: ["Stadium"],
    rules: [
      "Metal Pokémon (both yours and your opponent's) take 30 less damage from attacks from the opponent's Pokémon (after applying Weakness and Resistance).",
      "You may play only 1 Stadium card during your turn. Put it into the Active Spot, and discard it if another Stadium comes into play. A Stadium with the same name can't be played.",
    ],
    number: "148",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/148.png",
      large: "https://images.pokemontcg.io/sv5/148_hires.png",
    },
    altArts: [
      {
        id: "sv5-148",
        number: "148",
        images: {
          small: "https://images.pokemontcg.io/sv5/148.png",
          large: "https://images.pokemontcg.io/sv5/148_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-149",
    name: "Future Booster Energy Capsule",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool", "Future"],
    rules: [
      "The Future Pokémon this card is attached to has no Retreat Cost, and the attacks it uses do 20 more damage to your opponent's Active Pokémon (before applying Weakness and Resistance).",
      "You may attach any number of Pokémon Tools to your Pokémon during your turn. You may attach only 1 Pokémon Tool to each Pokémon, and it stays attached.",
    ],
    number: "149",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/149.png",
      large: "https://images.pokemontcg.io/sv5/149_hires.png",
    },
    altArts: [
      {
        id: "sv5-149",
        number: "149",
        images: {
          small: "https://images.pokemontcg.io/sv5/149.png",
          large: "https://images.pokemontcg.io/sv5/149_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-77",
    name: "Gladion's Final Battle",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "You can use this card only when it is the last card in your hand.\nDuring this turn, attacks used by your Pokémon that don't have a Rule Box do 80 more damage to your opponent's Active Pokémon (before applying Weakness and Resistance). (Pokémon ex, Pokémon V_atk, etc. have Rule Boxes.)",
    ],
    number: "77",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-77/small",
      large: "https://images.scrydex.com/pokemon/me5-77/large",
    },
    altArts: [
      {
        id: "me5-77",
        number: "77",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-77/small",
          large: "https://images.scrydex.com/pokemon/me5-77/large",
        },
        flavorText: "",
      },
      {
        id: "me5-108",
        number: "108",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-108/small",
          large: "https://images.scrydex.com/pokemon/me5-108/large",
        },
        flavorText: "",
      },
      {
        id: "me5-118",
        number: "118",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-118/small",
          large: "https://images.scrydex.com/pokemon/me5-118/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-189",
    name: "Glass Trumpet",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "You can use this card only if you have any Tera Pokémon in play.  Choose up to 2 of your Benched Colorless Pokémon and attach a Basic Energy card from your discard pile to each of them.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "189",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-189/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-189/large",
    },
    altArts: [
      {
        id: "me2pt5-189",
        number: "189",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-189/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-189/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-260",
        number: "260",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-260/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-260/large",
        },
        flavorText: "",
      },
      {
        id: "sv7-135",
        number: "135",
        images: {
          small: "https://images.pokemontcg.io/sv7/135.png",
          large: "https://images.pokemontcg.io/sv7/135_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-110",
        number: "110",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/110.png",
          large: "https://images.pokemontcg.io/sv8pt5/110_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-136",
    name: "Grand Tree",
    supertype: "Trainer",
    subtypes: ["Stadium", "ACE SPEC"],
    rules: [
      "You can't have more than 1 ACE SPEC card in your deck.",
      "Once during each player's turn, that player may search their deck for a Stage 1 Pokémon that evolves from 1 of their Basic Pokémon and put it onto that Pokémon to evolve it. If that Pokémon was evolved in this way, that player may search their deck for a Stage 2 Pokémon that evolves from that Pokémon and put it onto that Pokémon to evolve it. Then, that player shuffles their deck. (Players can't evolve a Basic Pokémon during their first turn or a Basic Pokémon that was put into play this turn.)",
      "You may play only 1 Stadium card during your turn. Put it next to the Active Spot, and discard it if another Stadium comes into play. A Stadium with the same name can't be played.",
    ],
    number: "136",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/136.png",
      large: "https://images.pokemontcg.io/sv7/136_hires.png",
    },
    altArts: [
      {
        id: "sv7-136",
        number: "136",
        images: {
          small: "https://images.pokemontcg.io/sv7/136.png",
          large: "https://images.pokemontcg.io/sv7/136_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-166",
    name: "Granite Cave",
    supertype: "Trainer",
    subtypes: ["Stadium"],
    rules: [
      "Steven's Pokémon (both yours and your opponent's) take 30 less damage from attacks from the opponent's Pokémon (after applying Weakness and Resistance).",
      "You may play only 1 Stadium card during your turn. Put it next to the Active Spot, and discard it if another Stadium comes into play. A Stadium with the same name can't be played.",
    ],
    number: "166",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/166.png",
      large: "https://images.pokemontcg.io/sv10/166_hires.png",
    },
    altArts: [
      {
        id: "sv10-166",
        number: "166",
        images: {
          small: "https://images.pokemontcg.io/sv10/166.png",
          large: "https://images.pokemontcg.io/sv10/166_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-137",
    name: "Gravity Gemstone",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool"],
    rules: [
      "As long as the Pokémon this card is attached to is in the Active Spot, the Retreat Cost of both Active Pokémon is Colorless more.",
      "You may attach any number of Pokémon Tools to your Pokémon during your turn. You may attach only 1 Pokémon Tool to each Pokémon, and it stays attached.",
    ],
    number: "137",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/137.png",
      large: "https://images.pokemontcg.io/sv7/137_hires.png",
    },
    altArts: [
      {
        id: "sv7-137",
        number: "137",
        images: {
          small: "https://images.pokemontcg.io/sv7/137.png",
          large: "https://images.pokemontcg.io/sv7/137_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-177",
    name: "Gravity Mountain",
    supertype: "Trainer",
    subtypes: ["Stadium"],
    rules: [
      "Each Stage 2 Pokémon in play (both yours and your opponent's) gets -30 HP.",
      "You may play only 1 Stadium card during your turn. Put it into the Active Spot, and discard it if another Stadium comes into play. A Stadium with the same name can't be played.",
    ],
    number: "177",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/177.png",
      large: "https://images.pokemontcg.io/sv8/177_hires.png",
    },
    altArts: [
      {
        id: "sv8-177",
        number: "177",
        images: {
          small: "https://images.pokemontcg.io/sv8/177.png",
          large: "https://images.pokemontcg.io/sv8/177_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-250",
        number: "250",
        images: {
          small: "https://images.pokemontcg.io/sv8/250.png",
          large: "https://images.pokemontcg.io/sv8/250_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-78",
    name: "Great Haul Net",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Choose 1 or both:\n• Shuffle up to 3 Water Pokémon from your discard pile into your deck.\n• Shuffle up to 3 Basic Water Energy cards from your discard pile into your deck.",
    ],
    number: "78",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-78/small",
      large: "https://images.scrydex.com/pokemon/me4-78/large",
    },
    altArts: [
      {
        id: "me4-78",
        number: "78",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-78/small",
          large: "https://images.scrydex.com/pokemon/me4-78/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-90",
    name: "Grimsley's Move",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Look at the top 7 cards of your deck and put a Darkness Pokémon you find there onto your Bench. Shuffle the other cards and put them on the bottom of your deck. You can't use this card during your first turn.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "90",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/90.png",
      large: "https://images.pokemontcg.io/me2/90_hires.png",
    },
    altArts: [
      {
        id: "me2-90",
        number: "90",
        images: {
          small: "https://images.pokemontcg.io/me2/90.png",
          large: "https://images.pokemontcg.io/me2/90_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2-120",
        number: "120",
        images: {
          small: "https://images.pokemontcg.io/me2/120.png",
          large: "https://images.pokemontcg.io/me2/120_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-78",
    name: "Gwynn",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Discard up to 2 Pokémon that don't have a Rule Box from your hand, and draw 3 cards for each card you discarded in this way. (Pokémon ex, Pokémon V_atk, etc. have Rule Boxes.)",
    ],
    number: "78",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-78/small",
      large: "https://images.scrydex.com/pokemon/me5-78/large",
    },
    altArts: [
      {
        id: "me5-78",
        number: "78",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-78/small",
          large: "https://images.scrydex.com/pokemon/me5-78/large",
        },
        flavorText: "",
      },
      {
        id: "me5-109",
        number: "109",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-109/small",
          large: "https://images.scrydex.com/pokemon/me5-109/large",
        },
        flavorText: "",
      },
      {
        id: "me5-119",
        number: "119",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-119/small",
          large: "https://images.scrydex.com/pokemon/me5-119/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-111",
    name: "Haban Berry",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool"],
    rules: [
      "If the Pokémon this card is attached to is damaged by an attack from your opponent's Dragon Pokémon, it takes 60 less damage (after applying Weakness and Resistance), and discard this card.",
      "You may attach any number of Pokémon Tools to your Pokémon during your turn. You may attach only 1 Pokémon Tool to each Pokémon, and it stays attached.",
    ],
    number: "111",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/111.png",
      large: "https://images.pokemontcg.io/sv8pt5/111_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-111",
        number: "111",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/111.png",
          large: "https://images.pokemontcg.io/sv8pt5/111_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-150",
    name: "Hand Trimmer",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Each player discards cards from their hand until they have 5 cards in their hand. Your opponent discards first. (If a player has 5 or fewer cards in their hand, they do not discard.)",
      "You may play any number of Item cards during your turn.",
    ],
    number: "150",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/150.png",
      large: "https://images.pokemontcg.io/sv5/150_hires.png",
    },
    altArts: [
      {
        id: "sv5-150",
        number: "150",
        images: {
          small: "https://images.pokemontcg.io/sv5/150.png",
          large: "https://images.pokemontcg.io/sv5/150_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-150",
    name: "Handheld Fan",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool"],
    rules: [
      "If the Pokémon this card is attached to is in the Active Spot and is damaged by an attack from your opponent's Pokémon (even if this Pokémon is Knocked Out), move an Energy from the Attacking Pokémon to 1 of your opponent's Benched Pokémon.",
      "You may attach any number of Pokémon Tools to your Pokémon during your turn. You may attach only 1 Pokémon Tool to each Pokémon, and it stays attached.",
      "Attach a Pokémon Tool to 1 of your Pokémon that doesn't already have a Pokémon Tool attached.",
    ],
    number: "150",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/150.png",
      large: "https://images.pokemontcg.io/sv6/150_hires.png",
    },
    altArts: [
      {
        id: "sv6-150",
        number: "150",
        images: {
          small: "https://images.pokemontcg.io/sv6/150.png",
          large: "https://images.pokemontcg.io/sv6/150_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-83",
    name: "Harlequin",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Each player shuffles their hand into their deck. Then, flip a coin. If heads, you draw 5 cards, and your opponent draws 3 cards. If tails, you draw 3 cards, and your opponent draws 5 cards.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "83",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/83.png",
      large: "https://images.pokemontcg.io/rsv10pt5/83_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-83",
        number: "83",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/83.png",
          large: "https://images.pokemontcg.io/rsv10pt5/83_hires.png",
        },
        flavorText: "",
      },
      {
        id: "rsv10pt5-163",
        number: "163",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/163.png",
          large: "https://images.pokemontcg.io/rsv10pt5/163_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-151",
    name: "Hassel",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "You can use this card only if any of your Pokémon were Knocked Out during your opponent's last turn.    Look at the top 8 cards of your deck and put up to 3 of them into your hand. Shuffle the other cards back into your deck.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "151",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/151.png",
      large: "https://images.pokemontcg.io/sv6/151_hires.png",
    },
    altArts: [
      {
        id: "sv6-151",
        number: "151",
        images: {
          small: "https://images.pokemontcg.io/sv6/151.png",
          large: "https://images.pokemontcg.io/sv6/151_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-205",
        number: "205",
        images: {
          small: "https://images.pokemontcg.io/sv6/205.png",
          large: "https://images.pokemontcg.io/sv6/205_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-151",
    name: "Heavy Baton",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool"],
    rules: [
      "If the Pokémon this card is attached to has a Retreat Cost of exactly 4, is in the Active Spot, and is Knocked Out by damage from an attack from your opponent's Pokémon, move up to 3 Basic Energy cards from that Pokémon to your Benched Pokémon in any way you like.",
      "You may attach any number of Pokémon Tools to your Pokémon during your turn. You may attach only 1 Pokémon Tool to each Pokémon, and it stays attached.",
    ],
    number: "151",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/151.png",
      large: "https://images.pokemontcg.io/sv5/151_hires.png",
    },
    altArts: [
      {
        id: "sv5-151",
        number: "151",
        images: {
          small: "https://images.pokemontcg.io/sv5/151.png",
          large: "https://images.pokemontcg.io/sv5/151_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-152",
    name: "Hero's Cape",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool", "ACE SPEC"],
    rules: [
      "The Pokémon this card is attached to gets +100 HP.",
      "You may attach any number of Pokémon Tools to your Pokémon during your turn. You may attach only 1 Pokémon Tool to each Pokémon, and it stays attached.",
      "ACE SPEC: You can't have more than 1 ACE SPEC card in your deck.",
    ],
    number: "152",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/152.png",
      large: "https://images.pokemontcg.io/sv5/152_hires.png",
    },
    altArts: [
      {
        id: "sv5-152",
        number: "152",
        images: {
          small: "https://images.pokemontcg.io/sv5/152.png",
          large: "https://images.pokemontcg.io/sv5/152_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-84",
    name: "Hilda",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Search your deck for an Evolution Pokémon and an Energy card, reveal them, and put them into your hand. Then, shuffle your deck.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "84",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/84.png",
      large: "https://images.pokemontcg.io/rsv10pt5/84_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-84",
        number: "84",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/84.png",
          large: "https://images.pokemontcg.io/rsv10pt5/84_hires.png",
        },
        flavorText: "",
      },
      {
        id: "rsv10pt5-164",
        number: "164",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/164.png",
          large: "https://images.pokemontcg.io/rsv10pt5/164_hires.png",
        },
        flavorText: "",
      },
      {
        id: "rsv10pt5-171",
        number: "171",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/171.png",
          large: "https://images.pokemontcg.io/rsv10pt5/171_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-74",
    name: "Hole-Digging Shovel",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Discard the top 2 cards of your deck.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "74",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-74/small",
      large: "https://images.scrydex.com/pokemon/me3-74/large",
    },
    altArts: [
      {
        id: "me3-74",
        number: "74",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-74/small",
          large: "https://images.scrydex.com/pokemon/me3-74/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-147",
    name: "Hop's Bag",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Search your deck for up to 2 Basic Hop's Pokémon and put them onto your Bench. Then, shuffle your deck.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "147",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/147.png",
      large: "https://images.pokemontcg.io/sv9/147_hires.png",
    },
    altArts: [
      {
        id: "sv9-147",
        number: "147",
        images: {
          small: "https://images.pokemontcg.io/sv9/147.png",
          large: "https://images.pokemontcg.io/sv9/147_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-148",
    name: "Hop's Choice Band",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool"],
    rules: [
      "Attacks used by the Hop's Pokémon this card is attached to cost Colorless less and do 30 more damage to your opponent's Active Pokémon (before applying Weakness and Resistance).",
      "You may attach any number of Pokémon Tools to your Pokémon during your turn. You may attach only 1 Pokémon Tool to each Pokémon, and it stays attached.",
    ],
    number: "148",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/148.png",
      large: "https://images.pokemontcg.io/sv9/148_hires.png",
    },
    altArts: [
      {
        id: "sv9-148",
        number: "148",
        images: {
          small: "https://images.pokemontcg.io/sv9/148.png",
          large: "https://images.pokemontcg.io/sv9/148_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-152",
    name: "Hyper Aroma",
    supertype: "Trainer",
    subtypes: ["Item", "ACE SPEC"],
    rules: [
      "You can't have more than 1 ACE SPEC card in your deck.",
      "Search your deck for up to 3 Stage 1 Pokémon, reveal them, and put them into your hand. Then, shuffle your deck.",
      "You may play any number of Item cards during your turn.",
      "ACE SPEC: You can't have more than 1 ACE SPEC card in your deck.",
    ],
    number: "152",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/152.png",
      large: "https://images.pokemontcg.io/sv6/152_hires.png",
    },
    altArts: [
      {
        id: "sv6-152",
        number: "152",
        images: {
          small: "https://images.pokemontcg.io/sv6/152.png",
          large: "https://images.pokemontcg.io/sv6/152_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-190",
    name: "Iris's Fighting Spirit",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "You can use this card only if you discard another card from your hand.  Draw cards until you have 6 cards in your hand.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "190",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-190/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-190/large",
    },
    altArts: [
      {
        id: "me2pt5-190",
        number: "190",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-190/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-190/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-292",
        number: "292",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-292/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-292/large",
        },
        flavorText: "",
      },
      {
        id: "sv9-149",
        number: "149",
        images: {
          small: "https://images.pokemontcg.io/sv9/149.png",
          large: "https://images.pokemontcg.io/sv9/149_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-180",
        number: "180",
        images: {
          small: "https://images.pokemontcg.io/sv9/180.png",
          large: "https://images.pokemontcg.io/sv9/180_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-118",
    name: "Iron Defender",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "During your opponent's next turn, all of your Metal Pokémon take 30 less damage from attacks from your opponent's Pokémon (after applying Weakness and Resistance). (This includes new Pokémon that come into play.)",
      "You may play any number of Item cards during your turn.",
    ],
    number: "118",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/118.png",
      large: "https://images.pokemontcg.io/me1/118_hires.png",
    },
    altArts: [
      {
        id: "me1-118",
        number: "118",
        images: {
          small: "https://images.pokemontcg.io/me1/118.png",
          large: "https://images.pokemontcg.io/me1/118_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me5-110",
        number: "110",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-110/small",
          large: "https://images.scrydex.com/pokemon/me5-110/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-75",
    name: "Jacinthe",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Heal 150 damage from 1 of your Psychic Pokémon.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "75",
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-75/small",
      large: "https://images.scrydex.com/pokemon/me3-75/large",
    },
    altArts: [
      {
        id: "me3-75",
        number: "75",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-75/small",
          large: "https://images.scrydex.com/pokemon/me3-75/large",
        },
        flavorText: "",
      },
      {
        id: "me3-110",
        number: "110",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-110/small",
          large: "https://images.scrydex.com/pokemon/me3-110/large",
        },
        flavorText: "",
      },
      {
        id: "me3-122",
        number: "122",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-122/small",
          large: "https://images.scrydex.com/pokemon/me3-122/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-261",
    name: "Jamming Tower",
    supertype: "Trainer",
    subtypes: ["Stadium"],
    rules: [
      "Pokémon Tools attached to each Pokémon (both yours and your opponent's) have no effect.",
      "You may play only 1 Stadium card during your turn. Put it next to the Active Spot, and discard it if another Stadium comes into play. A Stadium with the same name can’t be played.",
    ],
    number: "261",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-261/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-261/large",
    },
    altArts: [
      {
        id: "me2pt5-261",
        number: "261",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-261/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-261/large",
        },
        flavorText: "",
      },
      {
        id: "sv10-243",
        number: "243",
        images: {
          small: "https://images.pokemontcg.io/sv10/243.png",
          large: "https://images.pokemontcg.io/sv10/243_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-153",
        number: "153",
        images: {
          small: "https://images.pokemontcg.io/sv6/153.png",
          large: "https://images.pokemontcg.io/sv6/153_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-59",
    name: "Janine's Secret Art",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Choose up to 2 of your Darkness Pokémon. For each of those Pokémon, search your deck for a Basic Darkness Energy card and attach it to that Pokémon. Then, shuffle your deck. If you attached Energy to your Active Pokémon in this way, it is now Poisoned.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "59",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/59.png",
      large: "https://images.pokemontcg.io/sv6pt5/59_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-59",
        number: "59",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/59.png",
          large: "https://images.pokemontcg.io/sv6pt5/59_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6pt5-88",
        number: "88",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/88.png",
          large: "https://images.pokemontcg.io/sv6pt5/88_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-112",
        number: "112",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/112.png",
          large: "https://images.pokemontcg.io/sv8pt5/112_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-173",
        number: "173",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/173.png",
          large: "https://images.pokemontcg.io/sv8pt5/173_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-178",
    name: "Jasmine's Gaze",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "During your opponent's next turn, all of your Pokémon take 30 less damage from attacks from your opponent's Pokémon (after applying Weakness and Resistance). (This includes new Pokémon that come into play.)",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "178",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/178.png",
      large: "https://images.pokemontcg.io/sv8/178_hires.png",
    },
    altArts: [
      {
        id: "sv8-178",
        number: "178",
        images: {
          small: "https://images.pokemontcg.io/sv8/178.png",
          large: "https://images.pokemontcg.io/sv8/178_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-233",
        number: "233",
        images: {
          small: "https://images.pokemontcg.io/sv8/233.png",
          large: "https://images.pokemontcg.io/sv8/233_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-245",
        number: "245",
        images: {
          small: "https://images.pokemontcg.io/sv8/245.png",
          large: "https://images.pokemontcg.io/sv8/245_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-79",
    name: "Jett",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Draw a card for each of your opponent's Mega Evolution Pokémon ex in play.",
    ],
    number: "79",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-79/small",
      large: "https://images.scrydex.com/pokemon/me5-79/large",
    },
    altArts: [
      {
        id: "me5-79",
        number: "79",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-79/small",
          large: "https://images.scrydex.com/pokemon/me5-79/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-76",
    name: "Judge",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Each player shuffles their hand into their deck and draws 4 cards.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "76",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-76/small",
      large: "https://images.scrydex.com/pokemon/me3-76/large",
    },
    altArts: [
      {
        id: "me3-76",
        number: "76",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-76/small",
          large: "https://images.scrydex.com/pokemon/me3-76/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-91",
    name: "Jumbo Ice Cream",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Heal 80 damage from your Active Pokémon that has 3 or more Energy attached.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "91",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/91.png",
      large: "https://images.pokemontcg.io/me2/91_hires.png",
    },
    altArts: [
      {
        id: "me2-91",
        number: "91",
        images: {
          small: "https://images.pokemontcg.io/me2/91.png",
          large: "https://images.pokemontcg.io/me2/91_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me4-109",
        number: "109",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-109/small",
          large: "https://images.scrydex.com/pokemon/me4-109/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-154",
    name: "Kieran",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Choose 1:    • Switch your Active Pokémon with 1 of your Benched Pokémon.  • During this turn, attacks used by your Pokémon do 30 more damage to your opponent's Active Pokémon ex and Active Pokémon V (before applying Weakness and Resistance).",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "154",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/154.png",
      large: "https://images.pokemontcg.io/sv6/154_hires.png",
    },
    altArts: [
      {
        id: "sv6-154",
        number: "154",
        images: {
          small: "https://images.pokemontcg.io/sv6/154.png",
          large: "https://images.pokemontcg.io/sv6/154_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-206",
        number: "206",
        images: {
          small: "https://images.pokemontcg.io/sv6/206.png",
          large: "https://images.pokemontcg.io/sv6/206_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-218",
        number: "218",
        images: {
          small: "https://images.pokemontcg.io/sv6/218.png",
          large: "https://images.pokemontcg.io/sv6/218_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-113",
        number: "113",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/113.png",
          large: "https://images.pokemontcg.io/sv8pt5/113_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-174",
        number: "174",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/174.png",
          large: "https://images.pokemontcg.io/sv8pt5/174_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-138",
    name: "Kofu",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Put 2 cards from your hand on the bottom of your deck in any order. If you put 2 cards on the bottom of your deck in this way, draw 4 cards. (If you can't put 2 cards from your hand on the bottom of your deck, you can't use this card.)",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "138",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/138.png",
      large: "https://images.pokemontcg.io/sv7/138_hires.png",
    },
    altArts: [
      {
        id: "sv7-138",
        number: "138",
        images: {
          small: "https://images.pokemontcg.io/sv7/138.png",
          large: "https://images.pokemontcg.io/sv7/138_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv7-165",
        number: "165",
        images: {
          small: "https://images.pokemontcg.io/sv7/165.png",
          large: "https://images.pokemontcg.io/sv7/165_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-139",
    name: "Lacey",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Shuffle your hand into your deck. Then, draw 4 cards. If your opponent has 3 or fewer Prize cards remaining, draw 8 cards instead.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "139",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/139.png",
      large: "https://images.pokemontcg.io/sv7/139_hires.png",
    },
    altArts: [
      {
        id: "sv7-139",
        number: "139",
        images: {
          small: "https://images.pokemontcg.io/sv7/139.png",
          large: "https://images.pokemontcg.io/sv7/139_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv7-166",
        number: "166",
        images: {
          small: "https://images.pokemontcg.io/sv7/166.png",
          large: "https://images.pokemontcg.io/sv7/166_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv7-172",
        number: "172",
        images: {
          small: "https://images.pokemontcg.io/sv7/172.png",
          large: "https://images.pokemontcg.io/sv7/172_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-114",
        number: "114",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/114.png",
          large: "https://images.pokemontcg.io/sv8pt5/114_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-175",
        number: "175",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/175.png",
          large: "https://images.pokemontcg.io/sv8pt5/175_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-155",
    name: "Lana's Aid",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Put up to 3 in any combination of Pokémon that don't have a Rule Box and Basic Energy cards from your discard pile into your hand. (Pokémon ex, Pokémon V, etc. have Rule Boxes.)",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "155",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/155.png",
      large: "https://images.pokemontcg.io/sv6/155_hires.png",
    },
    altArts: [
      {
        id: "sv6-155",
        number: "155",
        images: {
          small: "https://images.pokemontcg.io/sv6/155.png",
          large: "https://images.pokemontcg.io/sv6/155_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-207",
        number: "207",
        images: {
          small: "https://images.pokemontcg.io/sv6/207.png",
          large: "https://images.pokemontcg.io/sv6/207_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-219",
        number: "219",
        images: {
          small: "https://images.pokemontcg.io/sv6/219.png",
          large: "https://images.pokemontcg.io/sv6/219_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-115",
    name: "Larry's Skill",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Discard your hand and search your deck for a Pokémon, a Supporter card, and a Basic Energy card, reveal them, and put them into your hand. Then, shuffle your deck.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "115",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/115.png",
      large: "https://images.pokemontcg.io/sv8pt5/115_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-115",
        number: "115",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/115.png",
          large: "https://images.pokemontcg.io/sv8pt5/115_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-139",
        number: "139",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/139.png",
          large: "https://images.pokemontcg.io/sv8pt5/139_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-244",
    name: "Levincia",
    supertype: "Trainer",
    subtypes: ["Stadium"],
    rules: [
      "Once during each player's turn, that player may put up to 2 Basic Lightning Energy cards from their discard pile into their hand.",
      "You may play only 1 Stadium card during your turn. Put it next to the Active Spot, and discard it if another Stadium comes into play. A Stadium with the same name can't be played.",
    ],
    number: "244",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/244.png",
      large: "https://images.pokemontcg.io/sv10/244_hires.png",
    },
    altArts: [
      {
        id: "sv10-244",
        number: "244",
        images: {
          small: "https://images.pokemontcg.io/sv10/244.png",
          large: "https://images.pokemontcg.io/sv10/244_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-150",
        number: "150",
        images: {
          small: "https://images.pokemontcg.io/sv9/150.png",
          large: "https://images.pokemontcg.io/sv9/150_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-191",
    name: "Light Ball",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool"],
    rules: [
      "Attacks used by the Pikachu ex this card is attached to do 50 more damage to your opponent's Active Pokémon ex (before applying Weakness and Resistance).",
      "You may attach any number of Pokémon Tools to your Pokémon during your turn. You may attach only 1 Pokémon Tool to each Pokémon, and it stays attached.",
    ],
    number: "191",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-191/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-191/large",
    },
    altArts: [
      {
        id: "me2pt5-191",
        number: "191",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-191/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-191/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-119",
    name: "Lillie's Determination",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Shuffle your hand into your deck. Then, draw 6 cards. If you have exactly 6 Prize cards remaining, draw 8 cards instead.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "119",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/119.png",
      large: "https://images.pokemontcg.io/me1/119_hires.png",
    },
    altArts: [
      {
        id: "me1-119",
        number: "119",
        images: {
          small: "https://images.pokemontcg.io/me1/119.png",
          large: "https://images.pokemontcg.io/me1/119_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-169",
        number: "169",
        images: {
          small: "https://images.pokemontcg.io/me1/169.png",
          large: "https://images.pokemontcg.io/me1/169_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-184",
        number: "184",
        images: {
          small: "https://images.pokemontcg.io/me1/184.png",
          large: "https://images.pokemontcg.io/me1/184_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-192",
        number: "192",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-192/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-192/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-151",
    name: "Lillie's Pearl",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool"],
    rules: [
      "If the Lillie's Pokémon this card is attached to is Knocked Out by damage from an attack from your opponent's Pokémon, that player takes 1 fewer Prize card.",
      "You may attach any number of Pokémon Tools to your Pokémon during your turn. You may attach only 1 Pokémon Tool to each Pokémon, and it stays attached.",
    ],
    number: "151",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/151.png",
      large: "https://images.pokemontcg.io/sv9/151_hires.png",
    },
    altArts: [
      {
        id: "sv9-151",
        number: "151",
        images: {
          small: "https://images.pokemontcg.io/sv9/151.png",
          large: "https://images.pokemontcg.io/sv9/151_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-179",
    name: "Lisia's Appeal",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Switch in 1 of your opponent's Benched Basic Pokémon to the Active Spot. If you do, the new Active Pokémon is now Confused.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "179",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/179.png",
      large: "https://images.pokemontcg.io/sv8/179_hires.png",
    },
    altArts: [
      {
        id: "sv8-179",
        number: "179",
        images: {
          small: "https://images.pokemontcg.io/sv8/179.png",
          large: "https://images.pokemontcg.io/sv8/179_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-234",
        number: "234",
        images: {
          small: "https://images.pokemontcg.io/sv8/234.png",
          large: "https://images.pokemontcg.io/sv8/234_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-246",
        number: "246",
        images: {
          small: "https://images.pokemontcg.io/sv8/246.png",
          large: "https://images.pokemontcg.io/sv8/246_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-180",
    name: "Lively Stadium",
    supertype: "Trainer",
    subtypes: ["Stadium"],
    rules: [
      "Each Basic Pokémon in play (both yours and your opponent's) gets +30 HP.",
      "You may play only 1 Stadium card during your turn. Put it into the Active Spot, and discard it if another Stadium comes into play. A Stadium with the same name can't be played.",
    ],
    number: "180",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/180.png",
      large: "https://images.pokemontcg.io/sv8/180_hires.png",
    },
    altArts: [
      {
        id: "sv8-180",
        number: "180",
        images: {
          small: "https://images.pokemontcg.io/sv8/180.png",
          large: "https://images.pokemontcg.io/sv8/180_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-156",
    name: "Love Ball",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Search your deck for a Pokémon with the same name as 1 of your opponent's Pokémon in play, reveal it, and put it into your hand. Then, shuffle your deck.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "156",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/156.png",
      large: "https://images.pokemontcg.io/sv6/156_hires.png",
    },
    altArts: [
      {
        id: "sv6-156",
        number: "156",
        images: {
          small: "https://images.pokemontcg.io/sv6/156.png",
          large: "https://images.pokemontcg.io/sv6/156_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-120",
    name: "Lt. Surge's Bargain",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Ask your opponent if each player may take a Prize card. If yes, each player takes a Prize card. If no, you draw 4 cards.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "120",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/120.png",
      large: "https://images.pokemontcg.io/me1/120_hires.png",
    },
    altArts: [
      {
        id: "me1-120",
        number: "120",
        images: {
          small: "https://images.pokemontcg.io/me1/120.png",
          large: "https://images.pokemontcg.io/me1/120_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-170",
        number: "170",
        images: {
          small: "https://images.pokemontcg.io/me1/170.png",
          large: "https://images.pokemontcg.io/me1/170_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-185",
        number: "185",
        images: {
          small: "https://images.pokemontcg.io/me1/185.png",
          large: "https://images.pokemontcg.io/me1/185_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-157",
    name: "Lucian",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Each player shuffles their hand and puts it on the bottom of their deck. If either player put any cards on the bottom of their deck in this way, each player flips a coin. If heads, that player draws 6 cards. If tails, they draw 3 cards.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "157",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/157.png",
      large: "https://images.pokemontcg.io/sv6/157_hires.png",
    },
    altArts: [
      {
        id: "sv6-157",
        number: "157",
        images: {
          small: "https://images.pokemontcg.io/sv6/157.png",
          large: "https://images.pokemontcg.io/sv6/157_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-208",
        number: "208",
        images: {
          small: "https://images.pokemontcg.io/sv6/208.png",
          large: "https://images.pokemontcg.io/sv6/208_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-158",
    name: "Lucky Helmet",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool"],
    rules: [
      "If the Pokémon this card is attached to is in the Active Spot and is damaged by an attack from your opponent's Pokémon (even if this Pokémon is Knocked Out), draw 2 cards.",
      "You may attach any number of Pokémon Tools to your Pokémon during your turn. You may attach only 1 Pokémon Tool to each Pokémon, and it stays attached.",
      "Attach a Pokémon Tool to 1 of your Pokémon that doesn't already have a Pokémon Tool attached.",
    ],
    number: "158",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/158.png",
      large: "https://images.pokemontcg.io/sv6/158_hires.png",
    },
    altArts: [
      {
        id: "sv6-158",
        number: "158",
        images: {
          small: "https://images.pokemontcg.io/sv6/158.png",
          large: "https://images.pokemontcg.io/sv6/158_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-77",
    name: "Lumiose City",
    supertype: "Trainer",
    subtypes: ["Stadium"],
    rules: [
      "Once during each player's turn, that player may search their deck for a Basic Pokémon and put it onto their Bench. Then, that player shuffles their deck. If a player searches their deck in this way, their turn ends.",
      "You may play only 1 Stadium card during your turn. Put it next to the Active Spot, and discard it if another Stadium comes into play. A Stadium with the same name can’t be played.",
    ],
    number: "77",
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-77/small",
      large: "https://images.scrydex.com/pokemon/me3-77/large",
    },
    altArts: [
      {
        id: "me3-77",
        number: "77",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-77/small",
          large: "https://images.scrydex.com/pokemon/me3-77/large",
        },
        flavorText: "",
      },
      {
        id: "me3-111",
        number: "111",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-111/small",
          large: "https://images.scrydex.com/pokemon/me3-111/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-78",
    name: "Lumiose Galette",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Heal 20 damage and remove a Special Condition from your Active Pokémon.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "78",
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-78/small",
      large: "https://images.scrydex.com/pokemon/me3-78/large",
    },
    altArts: [
      {
        id: "me3-78",
        number: "78",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-78/small",
          large: "https://images.scrydex.com/pokemon/me3-78/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-153",
    name: "Master Ball",
    supertype: "Trainer",
    subtypes: ["Item", "ACE SPEC"],
    rules: [
      "Search your deck for a Pokémon, reveal it, and put it into your hand. Then, shuffle your deck.",
      "You may play any number of Item cards during your turn.",
      "ACE SPEC: You can't have more than 1 ACE SPEC card in your deck.",
    ],
    number: "153",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/153.png",
      large: "https://images.pokemontcg.io/sv5/153_hires.png",
    },
    altArts: [
      {
        id: "sv5-153",
        number: "153",
        images: {
          small: "https://images.pokemontcg.io/sv5/153.png",
          large: "https://images.pokemontcg.io/sv5/153_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-116",
    name: "Max Rod",
    supertype: "Trainer",
    subtypes: ["Item", "ACE SPEC"],
    rules: [
      "You can't have more than 1 ACE SPEC card in your deck.",
      "Put up to 5 in any combination of Pokémon and Basic Energy cards from your discard pile into your hand.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "116",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/116.png",
      large: "https://images.pokemontcg.io/sv8pt5/116_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-116",
        number: "116",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/116.png",
          large: "https://images.pokemontcg.io/sv8pt5/116_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-154",
    name: "Maximum Belt",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool", "ACE SPEC"],
    rules: [
      "Attacks used by the Pokémon this card is attached to do 50 more damage to your opponent's Active Pokémon ex (before applying Weakness and Resistance).",
      "You may attach any number of Pokémon Tools to your Pokémon during your turn. You may attach only 1 Pokémon Tool to each Pokémon, and it stays attached.",
      "ACE SPEC: You can't have more than 1 ACE SPEC card in your deck.",
    ],
    number: "154",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/154.png",
      large: "https://images.pokemontcg.io/sv5/154_hires.png",
    },
    altArts: [
      {
        id: "sv5-154",
        number: "154",
        images: {
          small: "https://images.pokemontcg.io/sv5/154.png",
          large: "https://images.pokemontcg.io/sv5/154_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-117",
        number: "117",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/117.png",
          large: "https://images.pokemontcg.io/sv8pt5/117_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-181",
    name: "Meddling Memo",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Your opponent counts the cards in their hand, shuffles those cards, and puts them on the bottom of their deck. If they do, they draw that many cards.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "181",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/181.png",
      large: "https://images.pokemontcg.io/sv8/181_hires.png",
    },
    altArts: [
      {
        id: "sv8-181",
        number: "181",
        images: {
          small: "https://images.pokemontcg.io/sv8/181.png",
          large: "https://images.pokemontcg.io/sv8/181_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-121",
    name: "Mega Signal",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Search your deck for a Mega Evolution Pokémon ex, reveal it, and put it into your hand. Then, shuffle your deck.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "121",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/121.png",
      large: "https://images.pokemontcg.io/me1/121_hires.png",
    },
    altArts: [
      {
        id: "me1-121",
        number: "121",
        images: {
          small: "https://images.pokemontcg.io/me1/121.png",
          large: "https://images.pokemontcg.io/me1/121_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-171",
        number: "171",
        images: {
          small: "https://images.pokemontcg.io/me1/171.png",
          large: "https://images.pokemontcg.io/me1/171_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-193",
        number: "193",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-193/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-193/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-182",
    name: "Megaton Blower",
    supertype: "Trainer",
    subtypes: ["Item", "ACE SPEC"],
    rules: [
      "Discard all Pokémon Tools and Special Energy from all of your opponent's Pokémon, and discard a Stadium in play.",
      "You may play any number of Item cards during your turn.",
      "ACE SPEC: You can't have more than 1 ACE SPEC card in your deck.",
    ],
    number: "182",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/182.png",
      large: "https://images.pokemontcg.io/sv8/182_hires.png",
    },
    altArts: [
      {
        id: "sv8-182",
        number: "182",
        images: {
          small: "https://images.pokemontcg.io/sv8/182.png",
          large: "https://images.pokemontcg.io/sv8/182_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-183",
    name: "Miracle Headset",
    supertype: "Trainer",
    subtypes: ["Item", "ACE SPEC"],
    rules: [
      "Put up to 2 Supporter cards from your discard pile into your hand.",
      "You may play any number of Item cards during your turn.",
      "ACE SPEC: You can't have more than 1 ACE SPEC card in your deck.",
    ],
    number: "183",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/183.png",
      large: "https://images.pokemontcg.io/sv8/183_hires.png",
    },
    altArts: [
      {
        id: "sv8-183",
        number: "183",
        images: {
          small: "https://images.pokemontcg.io/sv8/183.png",
          large: "https://images.pokemontcg.io/sv8/183_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55c-18",
    name: "Misty",
    supertype: "Trainer",
    rules: [
      "Discard 2 of the other cards in your hand in order to play this card. If this turn's attack does damage to the Defending Pokémon (after applying Weakness and Resistance), and if the attacking Pokémon has Misty in its name, the attack does 20 more damage to the Defending Pokémon.",
    ],
    number: "18",
    images: {
      small: "https://images.scrydex.com/pokemon/me55c-18/small",
      large: "https://images.scrydex.com/pokemon/me55c-18/large",
    },
    altArts: [
      {
        id: "me55c-18",
        number: "18",
        images: {
          small: "https://images.scrydex.com/pokemon/me55c-18/small",
          large: "https://images.scrydex.com/pokemon/me55c-18/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-80",
    name: "Misty's Vitality",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Search your deck for up to 4 Basic Water Energy cards and attach them to 1 of your Pokémon. Then, shuffle your deck. Your turn ends.",
    ],
    number: "80",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-80/small",
      large: "https://images.scrydex.com/pokemon/me5-80/large",
    },
    altArts: [
      {
        id: "me5-80",
        number: "80",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-80/small",
          large: "https://images.scrydex.com/pokemon/me5-80/large",
        },
        flavorText: "",
      },
      {
        id: "me5-111",
        number: "111",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-111/small",
          large: "https://images.scrydex.com/pokemon/me5-111/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-155",
    name: "Morty's Conviction",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "You can use this card only if you discard another card from your hand.  Draw a card for each of your opponent's Benched Pokémon.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "155",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/155.png",
      large: "https://images.pokemontcg.io/sv5/155_hires.png",
    },
    altArts: [
      {
        id: "sv5-155",
        number: "155",
        images: {
          small: "https://images.pokemontcg.io/sv5/155.png",
          large: "https://images.pokemontcg.io/sv5/155_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv5-201",
        number: "201",
        images: {
          small: "https://images.pokemontcg.io/sv5/201.png",
          large: "https://images.pokemontcg.io/sv5/201_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv5-211",
        number: "211",
        images: {
          small: "https://images.pokemontcg.io/sv5/211.png",
          large: "https://images.pokemontcg.io/sv5/211_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-122",
    name: "Mystery Garden",
    supertype: "Trainer",
    subtypes: ["Stadium"],
    rules: [
      "Once during each player's turn, that player may discard an Energy card from their hand in order to draw cards until they have as many cards in their hand as they have Psychic Pokémon in play.",
      "You may play only 1 Stadium card during your turn. Put it next to the Active Spot, and discard it if another Stadium comes into play. A Stadium with the same name can't be played.",
    ],
    number: "122",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/122.png",
      large: "https://images.pokemontcg.io/me1/122_hires.png",
    },
    altArts: [
      {
        id: "me1-122",
        number: "122",
        images: {
          small: "https://images.pokemontcg.io/me1/122.png",
          large: "https://images.pokemontcg.io/me1/122_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-172",
        number: "172",
        images: {
          small: "https://images.pokemontcg.io/me1/172.png",
          large: "https://images.pokemontcg.io/me1/172_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-194",
        number: "194",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-194/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-194/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55c-101",
    name: "N",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Each player shuffles his or her hand into his or her deck. Then, each player draws a card for each of his or her remaining Prize cards.",
      "You may play only 1 Supporter card during your turn (before your attack).",
    ],
    number: "101",
    images: {
      small: "https://images.scrydex.com/pokemon/me55c-101/small",
      large: "https://images.scrydex.com/pokemon/me55c-101/large",
    },
    altArts: [
      {
        id: "me55c-101",
        number: "101",
        images: {
          small: "https://images.scrydex.com/pokemon/me55c-101/small",
          large: "https://images.scrydex.com/pokemon/me55c-101/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-152",
    name: "N's Castle",
    supertype: "Trainer",
    subtypes: ["Stadium"],
    rules: [
      "N's Pokémon in play (both yours and your opponent's) have no Retreat Cost.",
      "You may play only 1 Stadium card during your turn. Put it next to the Active Spot, and discard it if another Stadium comes into play. A Stadium with the same name can't be played.",
    ],
    number: "152",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/152.png",
      large: "https://images.pokemontcg.io/sv9/152_hires.png",
    },
    altArts: [
      {
        id: "sv9-152",
        number: "152",
        images: {
          small: "https://images.pokemontcg.io/sv9/152.png",
          large: "https://images.pokemontcg.io/sv9/152_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-195",
    name: "N's PP Up",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Attach a Basic Energy card from your discard pile to 1 of your Benched N's Pokémon.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "195",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-195/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-195/large",
    },
    altArts: [
      {
        id: "me2pt5-195",
        number: "195",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-195/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-195/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-262",
        number: "262",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-262/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-262/large",
        },
        flavorText: "",
      },
      {
        id: "sv9-153",
        number: "153",
        images: {
          small: "https://images.pokemontcg.io/sv9/153.png",
          large: "https://images.pokemontcg.io/sv9/153_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-83",
    name: "N's Plan",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Move up to 2 Energy from your Benched Pokémon to your Active Pokémon.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "83",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/83.png",
      large: "https://images.pokemontcg.io/zsv10pt5/83_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-83",
        number: "83",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/83.png",
          large: "https://images.pokemontcg.io/zsv10pt5/83_hires.png",
        },
        flavorText: "",
      },
      {
        id: "zsv10pt5-163",
        number: "163",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/163.png",
          large: "https://images.pokemontcg.io/zsv10pt5/163_hires.png",
        },
        flavorText: "",
      },
      {
        id: "zsv10pt5-170",
        number: "170",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/170.png",
          large: "https://images.pokemontcg.io/zsv10pt5/170_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-79",
    name: "Naveen",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Draw cards until you have 5 cards in your hand. Before drawing cards, you may discard any number of cards from your hand. (If you can't draw any cards in this way, you can't use this card.)",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "79",
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-79/small",
      large: "https://images.scrydex.com/pokemon/me3-79/large",
    },
    altArts: [
      {
        id: "me3-79",
        number: "79",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-79/small",
          large: "https://images.scrydex.com/pokemon/me3-79/large",
        },
        flavorText: "",
      },
      {
        id: "me3-112",
        number: "112",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-112/small",
          large: "https://images.scrydex.com/pokemon/me3-112/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-60",
    name: "Neutralization Zone",
    supertype: "Trainer",
    subtypes: ["Stadium", "ACE SPEC"],
    rules: [
      "You can't have more than 1 ACE SPEC card in your deck.",
      "Prevent all damage done to Pokémon that don't have a Rule Box (both yours and your opponent's) by attacks from the opponent's Pokémon ex and Pokémon V. (Pokémon ex, Pokémon V, etc. have Rule Boxes.)    This card can't be put into your hand or deck from the discard pile.",
      "You may play only 1 Stadium card during your turn. Put it next to the Active Spot, and discard it if another Stadium comes into play. A Stadium with the same name can't be played.",
    ],
    number: "60",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/60.png",
      large: "https://images.pokemontcg.io/sv6pt5/60_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-60",
        number: "60",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/60.png",
          large: "https://images.pokemontcg.io/sv6pt5/60_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-173",
    name: "Night Stretcher",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Put a Pokémon or a Basic Energy card from your discard pile into your hand.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "173",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/me1/173.png",
      large: "https://images.pokemontcg.io/me1/173_hires.png",
    },
    altArts: [
      {
        id: "me1-173",
        number: "173",
        images: {
          small: "https://images.pokemontcg.io/me1/173.png",
          large: "https://images.pokemontcg.io/me1/173_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-196",
        number: "196",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-196/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-196/large",
        },
        flavorText: "",
      },
      {
        id: "sv6pt5-61",
        number: "61",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/61.png",
          large: "https://images.pokemontcg.io/sv6pt5/61_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-251",
        number: "251",
        images: {
          small: "https://images.pokemontcg.io/sv8/251.png",
          large: "https://images.pokemontcg.io/sv8/251_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-197",
    name: "Nighttime Mine",
    supertype: "Trainer",
    subtypes: ["Stadium"],
    rules: [
      "Attacks used by each Tera Pokémon in play (both yours and your opponent's) cost Colorless more.",
      "You may play only 1 Stadium card during your turn. Put it next to the Active Spot, and discard it if another Stadium comes into play. A Stadium with the same name can’t be played.",
    ],
    number: "197",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-197/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-197/large",
    },
    altArts: [
      {
        id: "me2pt5-197",
        number: "197",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-197/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-197/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-140",
    name: "Occa Berry",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool"],
    rules: [
      "If the Pokémon this card is attached to is damaged by an attack from your opponent's Fire Pokémon, it takes 60 less damage (after applying Weakness and Resistance), and discard this card.",
      "You may attach any number of Pokémon Tools to your Pokémon during your turn. You may attach only 1 Pokémon Tool to each Pokémon, and it stays attached.",
    ],
    number: "140",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/140.png",
      large: "https://images.pokemontcg.io/sv7/140_hires.png",
    },
    altArts: [
      {
        id: "sv7-140",
        number: "140",
        images: {
          small: "https://images.pokemontcg.io/sv7/140.png",
          large: "https://images.pokemontcg.io/sv7/140_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-159",
    name: "Ogre's Mask",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      'Choose a Pokémon ex in your discard pile that has "Ogerpon" in its name, and switch it with 1 of your Pokémon ex in play that has "Ogerpon" in its name. Any attached cards, damage counters, Special Conditions, turns in play, and any other effects remain on the new Pokémon.',
      "You may play any number of Item cards during your turn.",
    ],
    number: "159",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/159.png",
      large: "https://images.pokemontcg.io/sv6/159_hires.png",
    },
    altArts: [
      {
        id: "sv6-159",
        number: "159",
        images: {
          small: "https://images.pokemontcg.io/sv6/159.png",
          large: "https://images.pokemontcg.io/sv6/159_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-118",
        number: "118",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/118.png",
          large: "https://images.pokemontcg.io/sv8pt5/118_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "svp-150",
    name: "Paradise Resort",
    supertype: "Trainer",
    subtypes: ["Stadium"],
    rules: [
      "The Retreat Cost of each Psyduck in play (both yours and your opponent's) is Colorless less.",
      "You may play only 1 Stadium card during your turn. Put it next to the Active Spot, and discard it if another Stadium comes into play. A Stadium with the same name can't be played.",
    ],
    number: "150",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/svp/150.png",
      large: "https://images.pokemontcg.io/svp/150_hires.png",
    },
    altArts: [
      {
        id: "svp-150",
        number: "150",
        images: {
          small: "https://images.pokemontcg.io/svp/150.png",
          large: "https://images.pokemontcg.io/svp/150_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-184",
    name: "Passho Berry",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool"],
    rules: [
      "If the Pokémon this card is attached to is damaged by an attack from your opponent's Water Pokémon, it takes 60 less damage (after applying Weakness and Resistance), and discard this card.",
      "You may attach any number of Pokémon Tools to your Pokémon during your turn. You may attach only 1 Pokémon Tool to each Pokémon, and it stays attached.",
      "Attach a Pokémon Tool to 1 of your Pokémon that doesn't already have a Pokémon Tool attached.",
    ],
    number: "184",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/184.png",
      large: "https://images.pokemontcg.io/sv8/184_hires.png",
    },
    altArts: [
      {
        id: "sv8-184",
        number: "184",
        images: {
          small: "https://images.pokemontcg.io/sv8/184.png",
          large: "https://images.pokemontcg.io/sv8/184_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-141",
    name: "Payapa Berry",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool"],
    rules: [
      "If the Pokémon this card is attached to is damaged by an attack from your opponent's Psychic Pokémon, it takes 60 less damage (after applying Weakness and Resistance), and discard this card.",
      "You may attach any number of Pokémon Tools to your Pokémon during your turn. You may attach only 1 Pokémon Tool to each Pokémon, and it stays attached.",
    ],
    number: "141",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/141.png",
      large: "https://images.pokemontcg.io/sv7/141_hires.png",
    },
    altArts: [
      {
        id: "sv7-141",
        number: "141",
        images: {
          small: "https://images.pokemontcg.io/sv7/141.png",
          large: "https://images.pokemontcg.io/sv7/141_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-156",
    name: "Perilous Jungle",
    supertype: "Trainer",
    subtypes: ["Stadium"],
    rules: [
      "During Pokémon Checkup, put 2 more damage counters on each Poisoned non-Darkness Pokémon (both yours and your opponent's).",
      "You may play only 1 Stadium card during your turn. Put it next to the Active Spot, and discard it if another Stadium comes into play. A Stadium with the same name can't be played.",
      "You may play only 1 Stadium card during your turn. Put it into the Active Spot, and discard it if another Stadium comes into play. A Stadium with the same name can't be played.",
    ],
    number: "156",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/156.png",
      large: "https://images.pokemontcg.io/sv5/156_hires.png",
    },
    altArts: [
      {
        id: "sv5-156",
        number: "156",
        images: {
          small: "https://images.pokemontcg.io/sv5/156.png",
          large: "https://images.pokemontcg.io/sv5/156_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-160",
    name: "Perrin",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Reveal up to 2 Pokémon in your hand and put them into your deck. If you do, search your deck for up to that many Pokémon, reveal them, and put them into your hand. Then, shuffle your deck.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "160",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/160.png",
      large: "https://images.pokemontcg.io/sv6/160_hires.png",
    },
    altArts: [
      {
        id: "sv6-160",
        number: "160",
        images: {
          small: "https://images.pokemontcg.io/sv6/160.png",
          large: "https://images.pokemontcg.io/sv6/160_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-209",
        number: "209",
        images: {
          small: "https://images.pokemontcg.io/sv6/209.png",
          large: "https://images.pokemontcg.io/sv6/209_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-220",
        number: "220",
        images: {
          small: "https://images.pokemontcg.io/sv6/220.png",
          large: "https://images.pokemontcg.io/sv6/220_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-79",
    name: "Philippe",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Attach up to 2 Basic Metal Energy cards from your discard pile to 1 of your Metal Pokémon.",
    ],
    number: "79",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-79/small",
      large: "https://images.scrydex.com/pokemon/me4-79/large",
    },
    altArts: [
      {
        id: "me4-79",
        number: "79",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-79/small",
          large: "https://images.scrydex.com/pokemon/me4-79/large",
        },
        flavorText: "",
      },
      {
        id: "me4-110",
        number: "110",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-110/small",
          large: "https://images.scrydex.com/pokemon/me4-110/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "svp-114",
    name: "Picnicker",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Flip a coin. If heads, draw 4 cards. If tails, draw 2 cards.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "114",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/svp/114.png",
      large: "https://images.pokemontcg.io/svp/114_hires.png",
    },
    altArts: [
      {
        id: "svp-114",
        number: "114",
        images: {
          small: "https://images.pokemontcg.io/svp/114.png",
          large: "https://images.pokemontcg.io/svp/114_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-80",
    name: "Poké Ball",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Flip a coin. If heads, search your deck for a Pokémon, reveal it, and put it into your hand. Then, shuffle your deck.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "80",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-80/small",
      large: "https://images.scrydex.com/pokemon/me3-80/large",
    },
    altArts: [
      {
        id: "me3-80",
        number: "80",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-80/small",
          large: "https://images.scrydex.com/pokemon/me3-80/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-198",
    name: "Poké Pad",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Search your deck for a Pokémon that doesn't have a Rule Box, reveal it, and put it into your hand. Then, shuffle your deck. (Pokémon ex, Pokémon V, etc. have Rule Boxes.)",
      "You may play any number of Item cards during your turn.",
    ],
    number: "198",
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-198/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-198/large",
    },
    altArts: [
      {
        id: "me2pt5-198",
        number: "198",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-198/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-198/large",
        },
        flavorText: "",
      },
      {
        id: "me3-81",
        number: "81",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-81/small",
          large: "https://images.scrydex.com/pokemon/me3-81/large",
        },
        flavorText: "",
      },
      {
        id: "me3-113",
        number: "113",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-113/small",
          large: "https://images.scrydex.com/pokemon/me3-113/large",
        },
        flavorText: "",
      },
      {
        id: "me55-126",
        number: "126",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-126/small",
          large: "https://images.scrydex.com/pokemon/me55-126/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-62",
    name: "Poké Vital A",
    supertype: "Trainer",
    subtypes: ["Item", "ACE SPEC"],
    rules: [
      "You can't have more than 1 ACE SPEC card in your deck.",
      "Heal 150 damage from 1 of your Pokémon.    This card can't be put into your hand or deck from the discard pile.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "62",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/62.png",
      large: "https://images.pokemontcg.io/sv6pt5/62_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-62",
        number: "62",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/62.png",
          large: "https://images.pokemontcg.io/sv6pt5/62_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-84",
    name: "Pokégear 3.0",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Look at the top 7 cards of your deck. You may reveal a Supporter card you find there and put it into your hand. Shuffle the other cards back into your deck.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "84",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/84.png",
      large: "https://images.pokemontcg.io/zsv10pt5/84_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-84",
        number: "84",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/84.png",
          large: "https://images.pokemontcg.io/zsv10pt5/84_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-82",
    name: "Pokémon Catcher",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Flip a coin. If heads, switch in 1 of your opponent's Benched Pokémon to the Active Spot.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "82",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-82/small",
      large: "https://images.scrydex.com/pokemon/me3-82/large",
    },
    altArts: [
      {
        id: "me3-82",
        number: "82",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-82/small",
          large: "https://images.scrydex.com/pokemon/me3-82/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-123",
    name: "Pokémon Center Lady",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Heal 60 damage from 1 of your Pokémon, and it recovers from all Special Conditions.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "123",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/123.png",
      large: "https://images.pokemontcg.io/me1/123_hires.png",
    },
    altArts: [
      {
        id: "me1-123",
        number: "123",
        images: {
          small: "https://images.pokemontcg.io/me1/123.png",
          large: "https://images.pokemontcg.io/me1/123_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-154",
    name: "Postwick",
    supertype: "Trainer",
    subtypes: ["Stadium"],
    rules: [
      "Attacks used by Hop's Pokémon (both yours and your opponent's) do 30 more damage to the opponent's Active Pokémon (before applying Weakness and Resistance).",
      "You may play only 1 Stadium card during your turn. Put it next to the Active Spot, and discard it if another Stadium comes into play. A Stadium with the same name can't be played.",
    ],
    number: "154",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/154.png",
      large: "https://images.pokemontcg.io/sv9/154_hires.png",
    },
    altArts: [
      {
        id: "sv9-154",
        number: "154",
        images: {
          small: "https://images.pokemontcg.io/sv9/154.png",
          large: "https://images.pokemontcg.io/sv9/154_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-83",
    name: "Potion",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Heal 30 damage from 1 of your Pokémon.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "83",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-83/small",
      large: "https://images.scrydex.com/pokemon/me3-83/large",
    },
    altArts: [
      {
        id: "me3-83",
        number: "83",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-83/small",
          large: "https://images.scrydex.com/pokemon/me3-83/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-63",
    name: "Powerglass",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool"],
    rules: [
      "At the end of your turn (after your attack), if the Pokémon this card is attached to is in the Active Spot, you may attach a Basic Energy card from your discard pile to it.",
      "You may attach any number of Pokémon Tools to your Pokémon during your turn. You may attach only 1 Pokémon Tool to each Pokémon, and it stays attached.",
    ],
    number: "63",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/63.png",
      large: "https://images.pokemontcg.io/sv6pt5/63_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-63",
        number: "63",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/63.png",
          large: "https://images.pokemontcg.io/sv6pt5/63_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6pt5-97",
        number: "97",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/97.png",
          large: "https://images.pokemontcg.io/sv6pt5/97_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-185",
    name: "Precious Trolley",
    supertype: "Trainer",
    subtypes: ["Item", "ACE SPEC"],
    rules: [
      "Search your deck for any number of Basic Pokémon and put them onto your Bench. Then, shuffle your deck.",
      "You may play any number of Item cards during your turn.",
      "ACE SPEC: You can't have more than 1 ACE SPEC card in your deck.",
    ],
    number: "185",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/185.png",
      large: "https://images.pokemontcg.io/sv8/185_hires.png",
    },
    altArts: [
      {
        id: "sv8-185",
        number: "185",
        images: {
          small: "https://images.pokemontcg.io/sv8/185.png",
          large: "https://images.pokemontcg.io/sv8/185_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-124",
    name: "Premium Power Pro",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "During this turn, attacks used by your Fighting Pokémon do 30 more damage to your opponent's Active Pokémon (before applying Weakness and Resistance).",
      "You may play any number of Item cards during your turn.",
    ],
    number: "124",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/124.png",
      large: "https://images.pokemontcg.io/me1/124_hires.png",
    },
    altArts: [
      {
        id: "me1-124",
        number: "124",
        images: {
          small: "https://images.pokemontcg.io/me1/124.png",
          large: "https://images.pokemontcg.io/me1/124_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-174",
        number: "174",
        images: {
          small: "https://images.pokemontcg.io/me1/174.png",
          large: "https://images.pokemontcg.io/me1/174_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-199",
        number: "199",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-199/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-199/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-157",
    name: "Prime Catcher",
    supertype: "Trainer",
    subtypes: ["Item", "ACE SPEC"],
    rules: [
      "Switch in 1 of your opponent's Benched Pokémon to the Active Spot. If you do, switch your Active Pokémon with 1 of your Benched Pokémon.",
      "You may play any number of Item cards during your turn.",
      "ACE SPEC: You can't have more than 1 ACE SPEC card in your deck.",
    ],
    number: "157",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/157.png",
      large: "https://images.pokemontcg.io/sv5/157_hires.png",
    },
    altArts: [
      {
        id: "sv5-157",
        number: "157",
        images: {
          small: "https://images.pokemontcg.io/sv5/157.png",
          large: "https://images.pokemontcg.io/sv5/157_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-119",
        number: "119",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/119.png",
          large: "https://images.pokemontcg.io/sv8pt5/119_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-80",
    name: "Prism Tower",
    supertype: "Trainer",
    subtypes: ["Stadium"],
    rules: [
      "Once during each player's turn, that player may discard 2 cards from their hand in order to draw a card.",
    ],
    number: "80",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-80/small",
      large: "https://images.scrydex.com/pokemon/me4-80/large",
    },
    altArts: [
      {
        id: "me4-80",
        number: "80",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-80/small",
          large: "https://images.scrydex.com/pokemon/me4-80/large",
        },
        flavorText: "",
      },
      {
        id: "me4-111",
        number: "111",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-111/small",
          large: "https://images.scrydex.com/pokemon/me4-111/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-92",
    name: "Punk Helmet",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool"],
    rules: [
      "If the Darkness Pokémon this card is attached to is in the Active Spot and is damaged by an attack from your opponent's Pokémon (even if this Pokémon is Knocked Out), place 4 damage counters on the Attacking Pokémon.",
      "You may attach any number of Pokémon Tools to your Pokémon during your turn. You may attach only 1 Pokémon Tool to each Pokémon, and it stays attached.",
    ],
    number: "92",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/92.png",
      large: "https://images.pokemontcg.io/me2/92_hires.png",
    },
    altArts: [
      {
        id: "me2-92",
        number: "92",
        images: {
          small: "https://images.pokemontcg.io/me2/92.png",
          large: "https://images.pokemontcg.io/me2/92_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2-121",
        number: "121",
        images: {
          small: "https://images.pokemontcg.io/me2/121.png",
          large: "https://images.pokemontcg.io/me2/121_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-161",
    name: "Raifort",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Look at the top 5 cards of your deck and discard any number of them. Put the other cards back in any order.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "161",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/161.png",
      large: "https://images.pokemontcg.io/sv6/161_hires.png",
    },
    altArts: [
      {
        id: "sv6-161",
        number: "161",
        images: {
          small: "https://images.pokemontcg.io/sv6/161.png",
          large: "https://images.pokemontcg.io/sv6/161_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-125",
    name: "Rare Candy",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Choose 1 of your Basic Pokémon in play. If you have a Stage 2 card in your hand that evolves from that Pokémon, put that card onto the Basic Pokémon to evolve it, skipping the Stage 1. You can't use this card during your first turn or on a Basic Pokémon that was put into play this turn.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "125",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/125.png",
      large: "https://images.pokemontcg.io/me1/125_hires.png",
    },
    altArts: [
      {
        id: "me1-125",
        number: "125",
        images: {
          small: "https://images.pokemontcg.io/me1/125.png",
          large: "https://images.pokemontcg.io/me1/125_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-175",
        number: "175",
        images: {
          small: "https://images.pokemontcg.io/me1/175.png",
          large: "https://images.pokemontcg.io/me1/175_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-158",
    name: "Reboot Pod",
    supertype: "Trainer",
    subtypes: ["Item", "Future", "ACE SPEC"],
    rules: [
      "Attach a Basic Energy card from your discard pile to each of your Future Pokémon.",
      "You may play any number of Item cards during your turn.",
      "ACE SPEC: You can't have more than 1 ACE SPEC card in your deck.",
    ],
    number: "158",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/158.png",
      large: "https://images.pokemontcg.io/sv5/158_hires.png",
    },
    altArts: [
      {
        id: "sv5-158",
        number: "158",
        images: {
          small: "https://images.pokemontcg.io/sv5/158.png",
          large: "https://images.pokemontcg.io/sv5/158_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-156",
    name: "Redeemable Ticket",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Count your Prize cards, shuffle them, and put them on the bottom of your deck. Then, take that many cards from the top of your deck and put them face down as your Prize cards.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "156",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/156.png",
      large: "https://images.pokemontcg.io/sv9/156_hires.png",
    },
    altArts: [
      {
        id: "sv9-156",
        number: "156",
        images: {
          small: "https://images.pokemontcg.io/sv9/156.png",
          large: "https://images.pokemontcg.io/sv9/156_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-126",
    name: "Repel",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Switch out your opponent's Active Pokémon to the Bench. (Your opponent chooses the new Active Pokémon.)",
      "You may play any number of Item cards during your turn.",
    ],
    number: "126",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/126.png",
      large: "https://images.pokemontcg.io/me1/126_hires.png",
    },
    altArts: [
      {
        id: "me1-126",
        number: "126",
        images: {
          small: "https://images.pokemontcg.io/me1/126.png",
          large: "https://images.pokemontcg.io/me1/126_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-159",
    name: "Rescue Board",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool"],
    rules: [
      "The Retreat Cost of the Pokémon this card is attached to is Colorless less. If that Pokémon's remaining HP is 30 or less, it has no Retreat Cost.",
      "You may attach any number of Pokémon Tools to your Pokémon during your turn. You may attach only 1 Pokémon Tool to each Pokémon, and it stays attached.",
    ],
    number: "159",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/159.png",
      large: "https://images.pokemontcg.io/sv5/159_hires.png",
    },
    altArts: [
      {
        id: "sv5-159",
        number: "159",
        images: {
          small: "https://images.pokemontcg.io/sv5/159.png",
          large: "https://images.pokemontcg.io/sv5/159_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-225",
        number: "225",
        images: {
          small: "https://images.pokemontcg.io/sv6/225.png",
          large: "https://images.pokemontcg.io/sv6/225_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-126",
        number: "126",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/126.png",
          large: "https://images.pokemontcg.io/sv8pt5/126_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-127",
    name: "Risky Ruins",
    supertype: "Trainer",
    subtypes: ["Stadium"],
    rules: [
      "Whenever any player puts a Basic non-Darkness Pokémon onto their Bench during their turn, place 2 damage counters on that Pokémon.",
      "You may play only 1 Stadium card during your turn. Put it next to the Active Spot, and discard it if another Stadium comes into play. A Stadium with the same name can't be played.",
    ],
    number: "127",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/127.png",
      large: "https://images.pokemontcg.io/me1/127_hires.png",
    },
    altArts: [
      {
        id: "me1-127",
        number: "127",
        images: {
          small: "https://images.pokemontcg.io/me1/127.png",
          large: "https://images.pokemontcg.io/me1/127_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-84",
    name: "Rosa's Encouragement",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "You can use this card only if you have more Prize cards remaining than your opponent.  Attach up to 2 Basic Energy cards from your discard pile to 1 of your Stage 2 Pokémon.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "84",
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-84/small",
      large: "https://images.scrydex.com/pokemon/me3-84/large",
    },
    altArts: [
      {
        id: "me3-84",
        number: "84",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-84/small",
          large: "https://images.scrydex.com/pokemon/me3-84/large",
        },
        flavorText: "",
      },
      {
        id: "me3-114",
        number: "114",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-114/small",
          large: "https://images.scrydex.com/pokemon/me3-114/large",
        },
        flavorText: "",
      },
      {
        id: "me3-123",
        number: "123",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-123/small",
          large: "https://images.scrydex.com/pokemon/me3-123/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-127",
    name: "Roto-Stick",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Look at the top 4 cards of your deck. You may reveal any number of Supporter cards you find there and put them into your hand. Shuffle the other cards back into your deck.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "127",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/127.png",
      large: "https://images.pokemontcg.io/sv8pt5/127_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-127",
        number: "127",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/127.png",
          large: "https://images.pokemontcg.io/sv8pt5/127_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-81",
    name: "Roxie's Performance",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "During your opponent's next turn, their Poisoned Pokémon can't retreat. (This includes newly Poisoned Pokémon.)",
    ],
    number: "81",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-81/small",
      large: "https://images.scrydex.com/pokemon/me4-81/large",
    },
    altArts: [
      {
        id: "me4-81",
        number: "81",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-81/small",
          large: "https://images.scrydex.com/pokemon/me4-81/large",
        },
        flavorText: "",
      },
      {
        id: "me4-112",
        number: "112",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-112/small",
          large: "https://images.scrydex.com/pokemon/me4-112/large",
        },
        flavorText: "",
      },
      {
        id: "me4-121",
        number: "121",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-121/small",
          large: "https://images.scrydex.com/pokemon/me4-121/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-157",
    name: "Ruffian",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Discard a Pokémon Tool and a Special Energy from 1 of your opponent's Pokémon.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "157",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/157.png",
      large: "https://images.pokemontcg.io/sv9/157_hires.png",
    },
    altArts: [
      {
        id: "sv9-157",
        number: "157",
        images: {
          small: "https://images.pokemontcg.io/sv9/157.png",
          large: "https://images.pokemontcg.io/sv9/157_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-181",
        number: "181",
        images: {
          small: "https://images.pokemontcg.io/sv9/181.png",
          large: "https://images.pokemontcg.io/sv9/181_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-81",
    name: "Rust Syndicate Grunt",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "You can use this card only if any of your Pokémon were Knocked Out during your opponent's last turn.\n\nDiscard an Energy from 1 of your opponent's Pokémon.",
    ],
    number: "81",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-81/small",
      large: "https://images.scrydex.com/pokemon/me5-81/large",
    },
    altArts: [
      {
        id: "me5-81",
        number: "81",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-81/small",
          large: "https://images.scrydex.com/pokemon/me5-81/large",
        },
        flavorText: "",
      },
      {
        id: "me5-112",
        number: "112",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-112/small",
          large: "https://images.scrydex.com/pokemon/me5-112/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-115",
    name: "Sacred Ash",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Shuffle up to 5 Pokémon from your discard pile into your deck.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "115",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-115/small",
      large: "https://images.scrydex.com/pokemon/me3-115/large",
    },
    altArts: [
      {
        id: "me3-115",
        number: "115",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-115/small",
          large: "https://images.scrydex.com/pokemon/me3-115/large",
        },
        flavorText: "",
      },
      {
        id: "sv10-168",
        number: "168",
        images: {
          small: "https://images.pokemontcg.io/sv10/168.png",
          large: "https://images.pokemontcg.io/sv10/168_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-93",
    name: "Sacred Charm",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool"],
    rules: [
      "The Pokémon this card is attached to takes 30 less damage from attacks from your opponent's Pokémon that have an Ability (after applying Weakness and Resistance).",
      "You may attach any number of Pokémon Tools to your Pokémon during your turn. You may attach only 1 Pokémon Tool to each Pokémon, and it stays attached.",
    ],
    number: "93",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/93.png",
      large: "https://images.pokemontcg.io/me2/93_hires.png",
    },
    altArts: [
      {
        id: "me2-93",
        number: "93",
        images: {
          small: "https://images.pokemontcg.io/me2/93.png",
          large: "https://images.pokemontcg.io/me2/93_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2-122",
        number: "122",
        images: {
          small: "https://images.pokemontcg.io/me2/122.png",
          large: "https://images.pokemontcg.io/me2/122_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-160",
    name: "Salvatore",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Search your deck for a card that has no Abilities and evolves from 1 of your Pokémon, and put it onto that Pokémon to evolve it. Then, shuffle your deck. You can use this card on a Pokémon you put down when you were setting up to play or on a Pokémon that was put into play this turn.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "160",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/160.png",
      large: "https://images.pokemontcg.io/sv5/160_hires.png",
    },
    altArts: [
      {
        id: "sv5-160",
        number: "160",
        images: {
          small: "https://images.pokemontcg.io/sv5/160.png",
          large: "https://images.pokemontcg.io/sv5/160_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv5-202",
        number: "202",
        images: {
          small: "https://images.pokemontcg.io/sv5/202.png",
          large: "https://images.pokemontcg.io/sv5/202_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv5-212",
        number: "212",
        images: {
          small: "https://images.pokemontcg.io/sv5/212.png",
          large: "https://images.pokemontcg.io/sv5/212_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-162",
    name: "Scoop Up Cyclone",
    supertype: "Trainer",
    subtypes: ["Item", "ACE SPEC"],
    rules: [
      "You can't have more than 1 ACE SPEC card in your deck.",
      "Put 1 of your Pokémon and all attached cards into your hand.",
      "You may play any number of Item cards during your turn.",
      "ACE SPEC: You can't have more than 1 ACE SPEC card in your deck.",
    ],
    number: "162",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/162.png",
      large: "https://images.pokemontcg.io/sv6/162_hires.png",
    },
    altArts: [
      {
        id: "sv6-162",
        number: "162",
        images: {
          small: "https://images.pokemontcg.io/sv6/162.png",
          large: "https://images.pokemontcg.io/sv6/162_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-128",
        number: "128",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/128.png",
          large: "https://images.pokemontcg.io/sv8pt5/128_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-186",
    name: "Scramble Switch",
    supertype: "Trainer",
    subtypes: ["Item", "ACE SPEC"],
    rules: [
      "Switch your Active Pokémon with 1 of your Benched Pokémon. If you do, you may move any amount of Energy from the Pokémon you moved to your Bench to the new Active Pokémon.",
      "You may play any number of Item cards during your turn.",
      "ACE SPEC: You can't have more than 1 ACE SPEC card in your deck.",
    ],
    number: "186",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/186.png",
      large: "https://images.pokemontcg.io/sv8/186_hires.png",
    },
    altArts: [
      {
        id: "sv8-186",
        number: "186",
        images: {
          small: "https://images.pokemontcg.io/sv8/186.png",
          large: "https://images.pokemontcg.io/sv8/186_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-163",
    name: "Secret Box",
    supertype: "Trainer",
    subtypes: ["Item", "ACE SPEC"],
    rules: [
      "You can't have more than 1 ACE SPEC card in your deck.",
      "You can use this card only if you discard 3 other cards from your hand.    Search your deck for an Item card, a Pokémon Tool card, a Supporter card, and a Stadium card, reveal them, and put them into your hand. Then, shuffle your deck.",
      "You may play any number of Item cards during your turn.",
      "ACE SPEC: You can't have more than 1 ACE SPEC card in your deck.",
    ],
    number: "163",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/163.png",
      large: "https://images.pokemontcg.io/sv6/163_hires.png",
    },
    altArts: [
      {
        id: "sv6-163",
        number: "163",
        images: {
          small: "https://images.pokemontcg.io/sv6/163.png",
          large: "https://images.pokemontcg.io/sv6/163_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-142",
    name: "Sparkling Crystal",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool", "ACE SPEC"],
    rules: [
      "You can't have more than 1 ACE SPEC card in your deck.",
      "When the Tera Pokémon this card is attached to uses an attack, that attack costs 1 Energy less. (The Energy can be of any type.)",
      "You may attach any number of Pokémon Tools to your Pokémon during your turn. You may attach only 1 Pokémon Tool to each Pokémon, and it stays attached.",
    ],
    number: "142",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/142.png",
      large: "https://images.pokemontcg.io/sv7/142_hires.png",
    },
    altArts: [
      {
        id: "sv7-142",
        number: "142",
        images: {
          small: "https://images.pokemontcg.io/sv7/142.png",
          large: "https://images.pokemontcg.io/sv7/142_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-129",
        number: "129",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/129.png",
          large: "https://images.pokemontcg.io/sv8pt5/129_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-82",
    name: "Special Red Card",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "You can use this card only if your opponent has 3 or fewer Prize cards remaining.\n\nYour opponent shuffles their hand and puts it on the bottom of their deck. If they put any cards on the bottom of their deck in this way, they draw 3 cards.",
    ],
    number: "82",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-82/small",
      large: "https://images.scrydex.com/pokemon/me4-82/large",
    },
    altArts: [
      {
        id: "me4-82",
        number: "82",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-82/small",
          large: "https://images.scrydex.com/pokemon/me4-82/large",
        },
        flavorText: "",
      },
      {
        id: "me4-113",
        number: "113",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-113/small",
          large: "https://images.scrydex.com/pokemon/me4-113/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-169",
    name: "Spikemuth Gym",
    supertype: "Trainer",
    subtypes: ["Stadium"],
    rules: [
      "Once during each player's turn, that player may search their deck for a Marnie's Pokémon, reveal it, and put it into their hand. Then, that player shuffles their deck.",
      "You may play only 1 Stadium card during your turn. Put it next to the Active Spot, and discard it if another Stadium comes into play. A Stadium with the same name can't be played.",
    ],
    number: "169",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/169.png",
      large: "https://images.pokemontcg.io/sv10/169_hires.png",
    },
    altArts: [
      {
        id: "sv10-169",
        number: "169",
        images: {
          small: "https://images.pokemontcg.io/sv10/169.png",
          large: "https://images.pokemontcg.io/sv10/169_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-128",
    name: "Strange Timepiece",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Devolve 1 of your evolved Psychic Pokémon by putting any number of Evolution cards on it into your hand. (That Pokémon can't evolve this turn.)",
      "You may play any number of Item cards during your turn.",
    ],
    number: "128",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/128.png",
      large: "https://images.pokemontcg.io/me1/128_hires.png",
    },
    altArts: [
      {
        id: "me1-128",
        number: "128",
        images: {
          small: "https://images.pokemontcg.io/me1/128.png",
          large: "https://images.pokemontcg.io/me1/128_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-158",
    name: "Super Potion",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Heal 60 damage from 1 of your Pokémon. If you healed any damage in this way, discard an Energy from that Pokémon.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "158",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/158.png",
      large: "https://images.pokemontcg.io/sv9/158_hires.png",
    },
    altArts: [
      {
        id: "sv9-158",
        number: "158",
        images: {
          small: "https://images.pokemontcg.io/sv9/158.png",
          large: "https://images.pokemontcg.io/sv9/158_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-200",
    name: "Surfer",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Switch your Active Pokémon with 1 of your Benched Pokémon. If you do, draw cards until you have 5 cards in your hand.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "200",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-200/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-200/large",
    },
    altArts: [
      {
        id: "me2pt5-200",
        number: "200",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-200/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-200/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-293",
        number: "293",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-293/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-293/large",
        },
        flavorText: "",
      },
      {
        id: "sv8-187",
        number: "187",
        images: {
          small: "https://images.pokemontcg.io/sv8/187.png",
          large: "https://images.pokemontcg.io/sv8/187_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-235",
        number: "235",
        images: {
          small: "https://images.pokemontcg.io/sv8/235.png",
          large: "https://images.pokemontcg.io/sv8/235_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-129",
    name: "Surfing Beach",
    supertype: "Trainer",
    subtypes: ["Stadium"],
    rules: [
      "Once during each player's turn, that player may switch their Active Water Pokémon with 1 of their Benched Water Pokémon.",
      "You may play only 1 Stadium card during your turn. Put it next to the Active Spot, and discard it if another Stadium comes into play. A Stadium with the same name can't be played.",
    ],
    number: "129",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/129.png",
      large: "https://images.pokemontcg.io/me1/129_hires.png",
    },
    altArts: [
      {
        id: "me1-129",
        number: "129",
        images: {
          small: "https://images.pokemontcg.io/me1/129.png",
          large: "https://images.pokemontcg.io/me1/129_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me4-114",
        number: "114",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-114/small",
          large: "https://images.scrydex.com/pokemon/me4-114/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-164",
    name: "Survival Brace",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool", "ACE SPEC"],
    rules: [
      "You can't have more than 1 ACE SPEC card in your deck.",
      "If the Pokémon this card is attached to has full HP and would be Knocked Out by damage from an attack from your opponent's Pokémon, it is not Knocked Out, and its remaining HP becomes 10. Then, discard this card.",
      "You may attach any number of Pokémon Tools to your Pokémon during your turn. You may attach only 1 Pokémon Tool to each Pokémon, and it stays attached.",
      "Attach a Pokémon Tool to 1 of your Pokémon that doesn't already have a Pokémon Tool attached.",
      "ACE SPEC: You can't have more than 1 ACE SPEC card in your deck.",
    ],
    number: "164",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/164.png",
      large: "https://images.pokemontcg.io/sv6/164_hires.png",
    },
    altArts: [
      {
        id: "sv6-164",
        number: "164",
        images: {
          small: "https://images.pokemontcg.io/sv6/164.png",
          large: "https://images.pokemontcg.io/sv6/164_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-130",
    name: "Switch",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Switch your Active Pokémon with 1 of your Benched Pokémon.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "130",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/130.png",
      large: "https://images.pokemontcg.io/me1/130_hires.png",
    },
    altArts: [
      {
        id: "me1-130",
        number: "130",
        images: {
          small: "https://images.pokemontcg.io/me1/130.png",
          large: "https://images.pokemontcg.io/me1/130_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2-123",
        number: "123",
        images: {
          small: "https://images.pokemontcg.io/me2/123.png",
          large: "https://images.pokemontcg.io/me2/123_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me55-127",
        number: "127",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-127/small",
          large: "https://images.scrydex.com/pokemon/me55-127/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-181",
    name: "TM Machine",
    supertype: "Trainer",
    subtypes: ["Item", "MEGA"],
    rules: [
      'Search your deck for up to 3 Pokémon Tool cards that have "Technical Machine" in their name, reveal them, and put them into your hand. Then, shuffle your deck.',
      "You may play any number of Item cards during your turn.",
    ],
    number: "181",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv10/181.png",
      large: "https://images.pokemontcg.io/sv10/181_hires.png",
    },
    altArts: [
      {
        id: "sv10-181",
        number: "181",
        images: {
          small: "https://images.pokemontcg.io/sv10/181.png",
          large: "https://images.pokemontcg.io/sv10/181_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-85",
    name: "Tarragon",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Put up to 4 in any combination of Fighting Pokémon and Basic Fighting Energy cards from your discard pile into your hand.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "85",
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-85/small",
      large: "https://images.scrydex.com/pokemon/me3-85/large",
    },
    altArts: [
      {
        id: "me3-85",
        number: "85",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-85/small",
          large: "https://images.scrydex.com/pokemon/me3-85/large",
        },
        flavorText: "",
      },
      {
        id: "me3-116",
        number: "116",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-116/small",
          large: "https://images.scrydex.com/pokemon/me3-116/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-201",
    name: "Team Rocket's Archer",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "You can use this card only if any of your Team Rocket's Pokémon were Knocked Out during your opponent's last turn.  Each player shuffles their hand into their deck. Then, you draw 5 cards, and your opponent draws 3 cards.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "201",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-201/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-201/large",
    },
    altArts: [
      {
        id: "me2pt5-201",
        number: "201",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-201/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-201/large",
        },
        flavorText: "",
      },
      {
        id: "sv10-170",
        number: "170",
        images: {
          small: "https://images.pokemontcg.io/sv10/170.png",
          large: "https://images.pokemontcg.io/sv10/170_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-223",
        number: "223",
        images: {
          small: "https://images.pokemontcg.io/sv10/223.png",
          large: "https://images.pokemontcg.io/sv10/223_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-202",
    name: "Team Rocket's Ariana",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Draw cards until you have 5 cards in your hand. If all of your Pokémon in play are Team Rocket's Pokémon, draw cards until you have 8 cards in your hand instead.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "202",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-202/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-202/large",
    },
    altArts: [
      {
        id: "me2pt5-202",
        number: "202",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-202/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-202/large",
        },
        flavorText: "",
      },
      {
        id: "sv10-171",
        number: "171",
        images: {
          small: "https://images.pokemontcg.io/sv10/171.png",
          large: "https://images.pokemontcg.io/sv10/171_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-224",
        number: "224",
        images: {
          small: "https://images.pokemontcg.io/sv10/224.png",
          large: "https://images.pokemontcg.io/sv10/224_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-237",
        number: "237",
        images: {
          small: "https://images.pokemontcg.io/sv10/237.png",
          large: "https://images.pokemontcg.io/sv10/237_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-172",
    name: "Team Rocket's Bother-Bot",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Turn 1 of your opponent's face-down Prize cards face up and choose a random card from your opponent's hand. Your opponent reveals that card. You may have your opponent switch those cards. (That Prize card remains face up for the rest of the game.)",
      "You may play any number of Item cards during your turn.",
    ],
    number: "172",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/172.png",
      large: "https://images.pokemontcg.io/sv10/172_hires.png",
    },
    altArts: [
      {
        id: "sv10-172",
        number: "172",
        images: {
          small: "https://images.pokemontcg.io/sv10/172.png",
          large: "https://images.pokemontcg.io/sv10/172_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-203",
    name: "Team Rocket's Factory",
    supertype: "Trainer",
    subtypes: ["Stadium"],
    rules: [
      'Once during each player\'s turn, if they played a Supporter card that has "Team Rocket" in its name from their hand this turn, they may draw 2 cards.',
      "You may play only 1 Stadium card during your turn. Put it next to the Active Spot, and discard it if another Stadium comes into play. A Stadium with the same name can’t be played.",
    ],
    number: "203",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-203/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-203/large",
    },
    altArts: [
      {
        id: "me2pt5-203",
        number: "203",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-203/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-203/large",
        },
        flavorText: "",
      },
      {
        id: "sv10-173",
        number: "173",
        images: {
          small: "https://images.pokemontcg.io/sv10/173.png",
          large: "https://images.pokemontcg.io/sv10/173_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-204",
    name: "Team Rocket's Giovanni",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Switch your Active Team Rocket's Pokémon with 1 of your Benched Team Rocket's Pokémon. If you do, switch in 1 of your opponent's Benched Pokémon to the Active Spot.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "204",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-204/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-204/large",
    },
    altArts: [
      {
        id: "me2pt5-204",
        number: "204",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-204/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-204/large",
        },
        flavorText: "",
      },
      {
        id: "sv10-174",
        number: "174",
        images: {
          small: "https://images.pokemontcg.io/sv10/174.png",
          large: "https://images.pokemontcg.io/sv10/174_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-225",
        number: "225",
        images: {
          small: "https://images.pokemontcg.io/sv10/225.png",
          large: "https://images.pokemontcg.io/sv10/225_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-238",
        number: "238",
        images: {
          small: "https://images.pokemontcg.io/sv10/238.png",
          large: "https://images.pokemontcg.io/sv10/238_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-205",
    name: "Team Rocket's Great Ball",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Flip a coin. If heads, search your deck for an Evolution Team Rocket's Pokémon, reveal it, and put it into your hand. If tails, search your deck for a Basic Team Rocket's Pokémon, reveal it, and put it into your hand. Then, shuffle your deck.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "205",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-205/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-205/large",
    },
    altArts: [
      {
        id: "me2pt5-205",
        number: "205",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-205/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-205/large",
        },
        flavorText: "",
      },
      {
        id: "sv10-175",
        number: "175",
        images: {
          small: "https://images.pokemontcg.io/sv10/175.png",
          large: "https://images.pokemontcg.io/sv10/175_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-206",
    name: "Team Rocket's Hypnotizer",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool"],
    rules: [
      "If the Team Rocket's Pokémon this card is attached to is in the Active Spot and is damaged by an attack from your opponent's Pokémon (even if this Team Rocket's Pokémon is Knocked Out), the Attacking Pokémon is now Asleep.",
      "You may attach any number of Pokémon Tools to your Pokémon during your turn. You may attach only 1 Pokémon Tool to each Pokémon, and it stays attached.",
    ],
    number: "206",
    nationalPokedexNumbers: [97],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-206/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-206/large",
    },
    altArts: [
      {
        id: "me2pt5-206",
        number: "206",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-206/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-206/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-207",
    name: "Team Rocket's Petrel",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Search your deck for a Trainer card, reveal it, and put it into your hand. Then, shuffle your deck.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "207",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-207/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-207/large",
    },
    altArts: [
      {
        id: "me2pt5-207",
        number: "207",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-207/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-207/large",
        },
        flavorText: "",
      },
      {
        id: "sv10-176",
        number: "176",
        images: {
          small: "https://images.pokemontcg.io/sv10/176.png",
          large: "https://images.pokemontcg.io/sv10/176_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-226",
        number: "226",
        images: {
          small: "https://images.pokemontcg.io/sv10/226.png",
          large: "https://images.pokemontcg.io/sv10/226_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-208",
    name: "Team Rocket's Proton",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "If you go first, you may use this card during your first turn.  Search your deck for up to 3 Basic Team Rocket's Pokémon, reveal them, and put them into your hand. Then, shuffle your deck.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "208",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-208/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-208/large",
    },
    altArts: [
      {
        id: "me2pt5-208",
        number: "208",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-208/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-208/large",
        },
        flavorText: "",
      },
      {
        id: "sv10-177",
        number: "177",
        images: {
          small: "https://images.pokemontcg.io/sv10/177.png",
          large: "https://images.pokemontcg.io/sv10/177_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-227",
        number: "227",
        images: {
          small: "https://images.pokemontcg.io/sv10/227.png",
          large: "https://images.pokemontcg.io/sv10/227_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-209",
    name: "Team Rocket's Transceiver",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      'Search your deck for a Supporter card that has "Team Rocket" in its name, reveal it, and put it into your hand. Then, shuffle your deck.',
      "You may play any number of Item cards during your turn.",
    ],
    number: "209",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-209/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-209/large",
    },
    altArts: [
      {
        id: "me2pt5-209",
        number: "209",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-209/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-209/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-263",
        number: "263",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-263/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-263/large",
        },
        flavorText: "",
      },
      {
        id: "sv10-178",
        number: "178",
        images: {
          small: "https://images.pokemontcg.io/sv10/178.png",
          large: "https://images.pokemontcg.io/sv10/178_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-179",
    name: "Team Rocket's Venture Bomb",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Flip a coin. If heads, put 2 damage counters on 1 of your opponent's Pokémon. If tails, put 2 damage counters on your Active Pokémon.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "179",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/179.png",
      large: "https://images.pokemontcg.io/sv10/179_hires.png",
    },
    altArts: [
      {
        id: "sv10-179",
        number: "179",
        images: {
          small: "https://images.pokemontcg.io/sv10/179.png",
          large: "https://images.pokemontcg.io/sv10/179_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-210",
    name: "Team Rocket's Watchtower",
    supertype: "Trainer",
    subtypes: ["Stadium"],
    rules: [
      "Colorless Pokémon in play (both yours and your opponent's) have no Abilities.",
      "You may play only 1 Stadium card during your turn. Put it next to the Active Spot, and discard it if another Stadium comes into play. A Stadium with the same name can’t be played.",
    ],
    number: "210",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-210/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-210/large",
    },
    altArts: [
      {
        id: "me2pt5-210",
        number: "210",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-210/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-210/large",
        },
        flavorText: "",
      },
      {
        id: "sv10-180",
        number: "180",
        images: {
          small: "https://images.pokemontcg.io/sv10/180.png",
          large: "https://images.pokemontcg.io/sv10/180_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-188",
    name: "Technical Machine: Fluorite",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool"],
    rules: [
      "The Pokémon this card is attached to can use the attack on this card. (You still need the necessary Energy to use this attack.) If this card is attached to 1 of your Pokémon, discard it at the end of your turn.",
      "You may attach any number of Pokémon Tools to your Pokémon during your turn. You may attach only 1 Pokémon Tool to each Pokémon, and it stays attached.",
      "Attach a Pokémon Tool to 1 of your Pokémon that doesn't already have a Pokémon Tool attached.",
    ],
    attacks: [
      {
        name: "Fluorite",
        cost: ["Grass", "Water", "Psychic"],
        convertedEnergyCost: 3,
        damage: "",
        text: "Discard all Energy from this Pokémon, and heal all damage from each of your Tera Pokémon.",
      },
    ],
    number: "188",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/188.png",
      large: "https://images.pokemontcg.io/sv8/188_hires.png",
    },
    altArts: [
      {
        id: "sv8-188",
        number: "188",
        images: {
          small: "https://images.pokemontcg.io/sv8/188.png",
          large: "https://images.pokemontcg.io/sv8/188_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-189",
    name: "Tera Orb",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Search your deck for a Tera Pokémon, reveal it, and put it into your hand. Then, shuffle your deck.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "189",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/189.png",
      large: "https://images.pokemontcg.io/sv8/189_hires.png",
    },
    altArts: [
      {
        id: "sv8-189",
        number: "189",
        images: {
          small: "https://images.pokemontcg.io/sv8/189.png",
          large: "https://images.pokemontcg.io/sv8/189_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-211",
    name: "Thick Scale",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool"],
    rules: [
      "The Dragon Pokémon this card is attached to takes 50 less damage from attacks from your opponent's Grass, Fire, Water, or Lightning Pokémon (after applying Weakness and Resistance).",
      "You may attach any number of Pokémon Tools to your Pokémon during your turn. You may attach only 1 Pokémon Tool to each Pokémon, and it stays attached.",
    ],
    number: "211",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-211/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-211/large",
    },
    altArts: [
      {
        id: "me2pt5-211",
        number: "211",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-211/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-211/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-85",
    name: "Tool Scrapper",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Choose up to 2 Pokémon Tools attached to Pokémon (yours or your opponent's) and discard them.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "85",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/85.png",
      large: "https://images.pokemontcg.io/rsv10pt5/85_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-85",
        number: "85",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/85.png",
          large: "https://images.pokemontcg.io/rsv10pt5/85_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-212",
        number: "212",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-212/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-212/large",
        },
        flavorText: "",
      },
      {
        id: "me4-115",
        number: "115",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-115/small",
          large: "https://images.scrydex.com/pokemon/me4-115/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-83",
    name: "Transformation Tome",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "You must play 2 Transformation Tome cards at once. (This effect works one time for 2 cards.)\n \nChoose a Basic Pokémon in your discard pile and switch it with 1 of your Basic Pokémon in play. Any attached cards, damage counters, Special Conditions, turns in play, and any other effects remain on the new Pokémon.",
    ],
    number: "83",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-83/small",
      large: "https://images.scrydex.com/pokemon/me4-83/large",
    },
    altArts: [
      {
        id: "me4-83",
        number: "83",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-83/small",
          large: "https://images.scrydex.com/pokemon/me4-83/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-131",
    name: "Treasure Tracker",
    supertype: "Trainer",
    subtypes: ["Item", "ACE SPEC"],
    rules: [
      "You can't have more than 1 ACE SPEC card in your deck.",
      "Search your deck for up to 5 Pokémon Tool cards, reveal them, and put them into your hand. Then, shuffle your deck.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "131",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/131.png",
      large: "https://images.pokemontcg.io/sv8pt5/131_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-131",
        number: "131",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/131.png",
          large: "https://images.pokemontcg.io/sv8pt5/131_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-82",
    name: "Tremendous Bomb",
    supertype: "Trainer",
    subtypes: ["Pokémon Tool"],
    rules: [
      "If the Pokémon this card is attached to isn't a Mega Evolution Pokémon ex, is in the Active Spot, and takes 240 or more damage from an attack from your opponent's Mega Evolution Pokémon ex (even if this Pokémon is Knocked Out), place 12 damage counters on the Attacking Pokémon. If you placed any damage counters in this way, discard this card.",
    ],
    number: "82",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-82/small",
      large: "https://images.scrydex.com/pokemon/me5-82/large",
    },
    altArts: [
      {
        id: "me5-82",
        number: "82",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-82/small",
          large: "https://images.scrydex.com/pokemon/me5-82/large",
        },
        flavorText: "",
      },
      {
        id: "me5-113",
        number: "113",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-113/small",
          large: "https://images.scrydex.com/pokemon/me5-113/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-190",
    name: "Tyme",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Tell your opponent the name of a Pokémon in your hand and put that Pokémon face down in front of you. Your opponent guesses that Pokémon's HP, and then you reveal it. If your opponent guessed right, they draw 4 cards. If they guessed wrong, you draw 4 cards. Then, return the Pokémon to your hand.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "190",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/190.png",
      large: "https://images.pokemontcg.io/sv8/190_hires.png",
    },
    altArts: [
      {
        id: "sv8-190",
        number: "190",
        images: {
          small: "https://images.pokemontcg.io/sv8/190.png",
          large: "https://images.pokemontcg.io/sv8/190_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-143",
        number: "143",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/143.png",
          large: "https://images.pokemontcg.io/sv8pt5/143_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-131",
    name: "Ultra Ball",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "You can use this card only if you discard 2 other cards from your hand.  Search your deck for a Pokémon, reveal it, and put it into your hand. Then, shuffle your deck.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "131",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/131.png",
      large: "https://images.pokemontcg.io/me1/131_hires.png",
    },
    altArts: [
      {
        id: "me1-131",
        number: "131",
        images: {
          small: "https://images.pokemontcg.io/me1/131.png",
          large: "https://images.pokemontcg.io/me1/131_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-213",
        number: "213",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-213/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-213/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-264",
        number: "264",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-264/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-264/large",
        },
        flavorText: "",
      },
      {
        id: "me55-128",
        number: "128",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-128/small",
          large: "https://images.scrydex.com/pokemon/me55-128/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-165",
    name: "Unfair Stamp",
    supertype: "Trainer",
    subtypes: ["Item", "ACE SPEC"],
    rules: [
      "You can't have more than 1 ACE SPEC card in your deck.",
      "You can use this card only if any of your Pokémon were Knocked Out during your opponent's last turn.    Each player shuffles their hand into their deck. Then, you draw 5 cards, and your opponent draws 2 cards.",
      "You may play any number of Item cards during your turn.",
      "ACE SPEC: You can't have more than 1 ACE SPEC card in your deck.",
    ],
    number: "165",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/165.png",
      large: "https://images.pokemontcg.io/sv6/165_hires.png",
    },
    altArts: [
      {
        id: "sv6-165",
        number: "165",
        images: {
          small: "https://images.pokemontcg.io/sv6/165.png",
          large: "https://images.pokemontcg.io/sv6/165_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-214",
    name: "Urbain",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Draw 3 cards.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "214",
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-214/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-214/large",
    },
    altArts: [
      {
        id: "me2pt5-214",
        number: "214",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-214/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-214/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-215",
    name: "Waitress",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Look at the top 6 cards of your deck and attach a Basic Energy card you find there to 1 of your Pokémon. Shuffle the other cards back into your deck.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "215",
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-215/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-215/large",
    },
    altArts: [
      {
        id: "me2pt5-215",
        number: "215",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-215/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-215/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-132",
    name: "Wally's Compassion",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Heal all damage from 1 of your Mega Evolution Pokémon ex. If you healed any damage in this way, put all Energy attached to that Pokémon into your hand.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "132",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/132.png",
      large: "https://images.pokemontcg.io/me1/132_hires.png",
    },
    altArts: [
      {
        id: "me1-132",
        number: "132",
        images: {
          small: "https://images.pokemontcg.io/me1/132.png",
          large: "https://images.pokemontcg.io/me1/132_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-176",
        number: "176",
        images: {
          small: "https://images.pokemontcg.io/me1/176.png",
          large: "https://images.pokemontcg.io/me1/176_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-186",
        number: "186",
        images: {
          small: "https://images.pokemontcg.io/me1/186.png",
          large: "https://images.pokemontcg.io/me1/186_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-94",
    name: "Wondrous Patch",
    supertype: "Trainer",
    subtypes: ["Item"],
    rules: [
      "Attach a Basic Psychic Energy card from your discard pile to 1 of your Benched Psychic Pokémon.",
      "You may play any number of Item cards during your turn.",
    ],
    number: "94",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/94.png",
      large: "https://images.pokemontcg.io/me2/94_hires.png",
    },
    altArts: [
      {
        id: "me2-94",
        number: "94",
        images: {
          small: "https://images.pokemontcg.io/me2/94.png",
          large: "https://images.pokemontcg.io/me2/94_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me3-117",
        number: "117",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-117/small",
          large: "https://images.scrydex.com/pokemon/me3-117/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-64",
    name: "Xerosic's Machinations",
    supertype: "Trainer",
    subtypes: ["Supporter"],
    rules: [
      "Your opponent discards cards from their hand until they have 3 cards in their hand.",
      "You may play only 1 Supporter card during your turn.",
    ],
    number: "64",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/64.png",
      large: "https://images.pokemontcg.io/sv6pt5/64_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-64",
        number: "64",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/64.png",
          large: "https://images.pokemontcg.io/sv6pt5/64_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6pt5-89",
        number: "89",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/89.png",
          large: "https://images.pokemontcg.io/sv6pt5/89_hires.png",
        },
        flavorText: "",
      },
    ],
  },
];

allStandardLegalTrainers.forEach((trainer) => {
  trainer.name = trainer.name.replace("Pokémon", "Pokemon");
  trainer.rules?.forEach((rule) => {
    rule = rule.replace("Pokémon", "Pokemon");
  });
});

export default allStandardLegalTrainers;
